<template>
  <div
    class="stake-vault"
    :class="{ dark: isDarkMode, day: !isDarkMode, [$i18n.locale]: true }"
  >
    <div class="toast" v-if="toastMsg">{{ toastMsg }}</div>
    <div class="cover" v-show="settingsVisible"></div>
    <div class="header" :class="{ 'header-visible': settingsVisible }">
      <img src="../assets/logo.png" class="logo" />
      <div class="header-right">
        <div class="mode-wrap">
          <img src="../assets/moon.png" class="moon" />
          <span class="mode">{{ $t("nightMode") }}</span>
          <Switcher
            class="mode-switcher"
            size="big"
            :value="isDarkMode"
            @switch="isDarkMode = !isDarkMode"
          ></Switcher>
        </div>
        <div class="locale-outer">
          <div class="locale-wrap" @click="localeMenuVisible = true">
            <img src="../assets/locale.png" />
            <span class="locale-label">{{ $t("switchLocale") }}</span>
            <div class="locale-slide">
              <span class="locale">{{
                $i18n.locale === "zh" ? "中文" : "English"
              }}</span>
              <span class="locale-arrow">&gt;</span>
            </div>
          </div>
          <div class="locale-menu" v-show="localeMenuVisible">
            <div class="whole" @click="localeMenuVisible = false"></div>
            <div
              class="locale-menu-item"
              v-for="(item, index) in localeList"
              :key="`locale-${index}`"
              @click="switchLocale(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <div class="locale-menu-mobile" v-show="localeMenuVisible">
            <div class="locale-menu-mobile-header">
              <span
                class="locale-menu-mobile-back"
                @click="localeMenuVisible = false"
                >&lt;</span
              >
              <img
                class="mobile-settings-close"
                @click="
                  localeMenuVisible = false;
                  settingsVisible = false;
                "
                :src="
                  isDarkMode
                    ? require('../assets/settings-close-dark.png')
                    : require('../assets/settings-close-day.png')
                "
              />
            </div>
            <div
              class="locale-menu-mobile-item"
              v-for="(item, index) in localeList"
              :key="`locale-${index}`"
              @click="switchLocale(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="mobile-settings-header">
          <span class="mobile-settings-title">{{ $t("settings") }}</span>
          <img
            class="mobile-settings-close"
            @click="settingsVisible = false"
            :src="
              isDarkMode
                ? require('../assets/settings-close-dark.png')
                : require('../assets/settings-close-day.png')
            "
          />
        </div>
      </div>
    </div>
    <div class="download-popover-bg" v-if="downloadVisible">
      <div class="download-popover">
        <div class="download-popover-header">
          <span class="download-popover-title">{{ $t("tips") }}</span>
          <img
            :src="
              isDarkMode
                ? require('../assets/settings-close-dark.png')
                : require('../assets/settings-close-day.png')
            "
            class="download-popover-close"
            @click="downloadVisible = false"
          />
        </div>
        <div class="download-popover-desc">{{ $t("downloadTips") }}</div>
        <div class="download-popover-download">
          <div class="download-popover-download-item">
            <img
              :src="
                isDarkMode
                  ? require('../assets/explorer-dark.png')
                  : require('../assets/explorer-day.png')
              "
              class="download-popover-download-explorer"
            />
            <a href="https://tpwallet.io" target="_blank"
              >https://tpwallet.io</a
            >
            <img
              :src="
                isDarkMode
                  ? require('../assets/copy-blue-dark.png')
                  : require('../assets/copy-blue-day.png')
              "
              v-clipboard:copy="'https://tpwallet.io'"
              v-clipboard:success="() => showToast(11)"
              class="download-popover-download-copy"
            />
          </div>
          <div class="download-popover-download-item">
            <img
              :src="
                isDarkMode
                  ? require('../assets/explorer-dark.png')
                  : require('../assets/explorer-day.png')
              "
              class="download-popover-download-explorer"
            />
            <a href="https://tokenpocket.pro" target="_blank"
              >https://tokenpocket.pro</a
            >
            <img
              :src="
                isDarkMode
                  ? require('../assets/copy-blue-dark.png')
                  : require('../assets/copy-blue-day.png')
              "
              v-clipboard:copy="'https://tokenpocket.pro'"
              v-clipboard:success="() => showToast(11)"
              class="download-popover-download-copy"
            />
          </div>
        </div>
        <button
          type="button"
          @click="downloadVisible = false"
          class="download-popover-confirm"
        >
          {{ $t("know") }}
        </button>
      </div>
    </div>
    <div class="title">
      <img src="../assets/safe.png" />
      <span>{{ $t("title") }}</span>
    </div>
    <div class="settings" @click="settingsVisible = true">
      {{ $t("settings") }}
    </div>
    <div class="content">
      <div class="left">
        <div class="overview">
          <div class="account-info" :class="$i18n.locale" v-if="account">
            <img src="../assets/eth.png" class="chain-logo" />
            <div class="account-wrap">
              <span class="account">{{ addressParseOmit(account, 5, 5) }}</span>
              <div class="account-switch" @click="switchTPWallet" v-if="isTP">
                <span class="account-switch-title">{{
                  $t("switchWallet")
                }}</span>
                <span class="account-switch-arrow">&gt;</span>
              </div>
            </div>
            <div class="balance-wrap">
              <p class="balance-label">{{ `${balance_display} ETH` }}</p>
              <p class="balance-value">{{ $t("balance") }}</p>
            </div>
          </div>
          <div class="switch" @click="initETH" v-else-if="connected.account">
            <span>{{ $t("networkError") }}</span>
            <span class="enter">&gt;</span>
          </div>
          <div class="connect" @click="initETH" v-else>
            {{ $t("connectWallet") }}
          </div>
          <div class="overview-staked" :class="{ dark: isDarkMode }">
            <div class="total-staked">
              <p class="staked-label">{{ $t("totalStake") }}</p>
              <p class="staked-value">
                <!-- {{ (Number(selfHost.staked) || 0) + (Number(joint.totalStaked) || 0) }} -->
                {{ jointSelfHostTotalStaked }}
              </p>
            </div>
            <div class="split-line"></div>
            <div class="staked-details">
              <div class="self-host-staked">
                <p class="staked-label">{{ `${$t("selfHostStake")} (ETH)` }}</p>
                <p class="staked-value">{{ selfHost.staked }}</p>
              </div>
              <div class="joint-staked">
                <p class="staked-label">{{ `${$t("jointStake")} (ETH)` }}</p>
                <p class="staked-value">{{ joint.totalStaked }}</p>
              </div>
            </div>
          </div>
          <div class="total-income">
            <span class="total-income-label">{{ $t("totalIncome") }}</span>
            <span class="total-income-value">{{
              `${
                jointAndSelfHostTotalReward
              } ETH`
            }}</span>
            <!-- <span class="total-income-value">{{
              `${
                Number(isNaN(joint.total_reward) ? 0 : joint.total_reward) +
                Number(isNaN(selfHost.total_reward) ? 0 : selfHost.total_reward)
              } ETH`
            }}</span> -->
          </div>
        </div>
        <div class="mobile-stake-wrap">
          <p class="mobile-stake-title">{{ $t("joinStake") }}</p>
          <div class="mobile-stake-content">
            <div
              class="mobile-stake-self-host"
              @click="
                statusType = 'selfHost';
                mobileHidden = false;
              "
            >
              <div class="mobile-stake-line">
                <span class="mobile-stake-label">{{
                  $t("selfHostStake")
                }}</span>
                <span class="mobile-stake-new">NEW</span>
              </div>
              <p class="mobile-stake-desc">
                {{ $t("mobileSelfHostStakeDesc") }}
              </p>
            </div>
            <div class="mobile-stake-split"></div>
            <div class="mobile-stake-joint" @click="mobileHidden = false">
              <p class="mobile-stake-label">{{ $t("jointStake") }}</p>
              <p class="mobile-stake-desc">{{ $t("mobileJointStakeDesc") }}</p>
            </div>
          </div>
        </div>
        <div class="knowledge">
          <p class="knowledge-title">{{ $t("knowledge") }}</p>
          <div class="knowledge-item" @click="openUrl($t('posUrl'))">
            {{ $t("knowETHPOS") }}
          </div>
          <!-- <div class="knowledge-split"></div> -->
          <div class="knowledge-item" @click="openUrl($t('commonQuestionUrl'))">
            {{ $t("aboutStakeCommonQustions") }}
          </div>
          <!-- <div class="knowledge-split"></div> -->
          <div class="knowledge-item" @click="openUrl($t('endpointListUrl'))">
            {{ $t("viewAllEndpoints") }}
          </div>
        </div>
      </div>
      <div
        class="right as-page"
        :class="{
          'mobile-hidden': mobileHidden,
          [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
          'with-cover': joint.historyVisible || selfHost.stakeVisible,
        }"
      >
        <div class="tabs stake-type-tabs">
          <div
            class="tab"
            :class="{ checked: statusType === 'joint' }"
            @click="statusType = 'joint'"
          >
            {{ $t("jointStake") }}
          </div>
          <div
            class="tab self-host-tab"
            :class="{ checked: statusType === 'selfHost' }"
            @click="statusType = 'selfHost'"
          >
            {{ $t("selfHostStake") }}
          </div>
        </div>
        <div
          class="details-joint"
          :class="$i18n.locale"
          v-show="statusType === 'joint'"
        >
          <div class="mobile-stake-page-header">
            <span class="mobile-stake-page-back" @click="mobileHidden = true"
              >&lt;</span
            >
            <span class="mobile-stake-page-title">{{ $t("jointStake") }}</span>
          </div>
          <div class="details-overview">
            <div class="total-stake">
              <p class="label">{{ $t("totalStake") }}</p>
              <p class="value">{{ joint.totalStaked }}</p>
            </div>
            <div class="total-income">
              <p class="label">{{ `${$t("totalIncome")} (ETH)` }}</p>
              <p class="value">
                {{ 
                  joint_total_reward != '0' ? joint_total_reward : "--" 
                }}
                </p>
            </div>
            <div class="estimate-annualized">
              <p class="label">{{ $t("estimateAnnualized") }}</p>
              <p class="value">{{ joint.estimate_annualized || "--" }}</p>
            </div>
            <div class="withdraw-income">
              <p class="label">
                <span>{{ $t("incomeTitle") }} (ETH)</span>
                <img @click="showModal(0)" v-if="isDarkMode" src="../assets/question-dark.png" alt=""/>
                <img @click="showModal(0)" v-else src="../assets/question-day.png" alt=""/>
              </p>
              <p class="label estimate-gas">{{ $t('estimateGas') }}: {{ estimateGas }} ETH</p>
              <div class="amount-wrap">
                <div class="amount">{{ joint.withdrawIncomeAmount != '0' ? joint.withdrawIncomeAmount : "--" }}</div>
                <input v-if="isTest" type="text" v-model="testWithdrawAmount" style="border: 1px solid #555; width: 50px">
                <button 
                  :class="{ disabled: joint.realWithdrawIncomeAmount == 0}"
                  class="amount btn" @click="onWithdrawReward"
                >
                  {{ $t('withdraw') }}
                </button>
              </div>
            </div>
          </div>
          <div class="tips-content" v-if="false">
            <p>{{ $t('withdrawIncomeTips') }}</p>
          </div>
          <div class="details-content">
            <div class="line-chart-wrap">
              <div v-if="false" class="tips-content tips-content-mobile">
                <p>{{ $t('withdrawIncomeTips') }}</p>
              </div>
              <div v-else class="withdraw-income-mobile">
                <div class="withdraw-income-left">
                  <div class="withdraw-income-content">
                    <span>{{ $t('incomeTitle') }}</span>
                    <img @click="showModal(0)" v-if="isDarkMode" src="../assets/question-dark.png" alt=""/>
                    <img @click="showModal(0)" v-else src="../assets/question-day.png" alt=""/>
                    <span>: {{ joint.withdrawIncomeAmount }} ETH</span>
                    <input v-if="isTest" type="text" v-model="testWithdrawAmount" style="border: 1px solid #555; width: 50px">
                  </div>
                  <div class="estimate-gas">{{ $t('estimateGas') }}: {{ estimateGas }} ETH</div>
                </div>

                <button 
                  type="button"
                  class="withdraw-income-btn" 
                  :class="{ disabled: joint.realWithdrawIncomeAmount == 0}"
                  @click="onWithdrawReward"
                >
                  {{ $t('withdraw') }}
                </button>
              </div>
              <div class="line"></div>
              <div class="line-chart-info">
                <span class="line-chart-title">{{
                  $t("yourEndpointTrend")
                }}</span>
                <div class="tabs">
                  <div
                    class="tab"
                    :class="{ checked: chart.interval === 'day' }"
                    @click="chart.interval = 'day'"
                  >
                    {{ $t("day") }}
                  </div>
                  <div
                    class="tab"
                    :class="{ checked: chart.interval === 'month' }"
                    @click="chart.interval = 'month'"
                  >
                    {{ $t("month") }}
                  </div>
                </div>
              </div>
              <div id="line-chart"></div>
              <!-- <div>
                <img src="../assets/04.png" />
              </div> -->
            </div>
            <div class="stake-wrap">
              <div
                class="stake-unstake fold-wrap"
                @click="mobileInnerHidden = false"
              >
                {{ $t("stakeOrUnstake") }}
              </div>
              <div
                class="stake-history fold-wrap"
                @click="joint.historyVisible = true"
              >
                <span class="stake-history-label">{{
                  $t("stakeHistory")
                }}</span>
                <div
                  class="stake-history-confirming"
                  @click.stop="openAddressExplorer"
                  v-if="joint.confirming_count"
                >
                  {{ $t("txConfirming", { amount: joint.confirming_count }) }}
                </div>
              </div>
              <div class="common-question fold-wrap">
                {{ $t("commonQuestion") }}
              </div>
              <div class="tabs">
                <div
                  class="tab"
                  :class="{ checked: joint.stakeAction === 'join' }"
                  @click="joint.stakeAction = 'join'"
                >
                  {{ $t("joinStake") }}
                </div>
                <div
                  class="tab"
                  :class="{ checked: joint.stakeAction === 'quit' }"
                  @click="joint.stakeAction = 'quit'"
                >
                  {{ $t("quitStake") }}
                </div>
              </div>
              <div
                class="mobile-stake-unstake-wrap as-page"
                :class="{
                  'mobile-inner-hidden': mobileInnerHidden,
                  [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
                }"
              >
                <div class="mobile-stake-page-header">
                  <span
                    class="mobile-stake-page-back"
                    @click="mobileInnerHidden = true"
                    >&lt;</span
                  >
                  <span class="mobile-stake-page-title">{{
                    $t("jointStake")
                  }}</span>
                </div>
                <div class="joint-stake-mobile-content">
                  <div class="joint-stake-overview">
                    <div class="inner-stake-user-status">
                      <img src="../assets/eth-mobile.png" />
                      <span class="inner-stake-user-address">{{
                        addressParseOmit(account, 5, 5)
                      }}</span>
                      <div class="inner-stake-user-right">
                        <p class="inner-stake-user-value">
                          {{ `${balance_display} ETH` }}
                        </p>
                        <p class="inner-stake-user-label">
                          {{ $t("balance") }}
                        </p>
                      </div>
                    </div>
                    <div class="joint-stake-overview-staked">
                      <span class="joint-stake-overview-staked-label">{{
                        $t("hasStaked")
                      }}</span>
                      <span class="joint-stake-overview-staked-value">{{
                        joint.totalStaked
                      }}</span>
                    </div>
                  </div>
                  <div class="tabs">
                    <div
                      class="tab"
                      :class="{ checked: joint.stakeAction === 'join' }"
                      @click="joint.stakeAction = 'join'"
                    >
                      {{ $t("joinStake") }}
                    </div>
                    <div
                      class="tab"
                      :class="{ checked: joint.stakeAction === 'quit' }"
                      @click="joint.stakeAction = 'quit'"
                    >
                      {{ $t("quitStake") }}
                    </div>
                  </div>
                </div>
                <div class="unstake-type-wrap" v-if="joint.stakeAction === 'quit'">
                  <div class="unstake-btn" @click="onUnStakeType(0)">
                    <span :class="{ active: unstake_type === 0}">{{ $t('normalQuit') }}</span>
                    <div class="bottom-line" :class="{ show: unstake_type === 1 }"></div>
                  </div>
                  <div class="unstake-btn" @click="onUnStakeType(1)">
                    <span :class="{ active: unstake_type === 1}">{{ $t('fastQuit') }}</span>
                    <div class="bottom-line" :class="{ show: unstake_type === 0 }"></div>
                  </div>
                </div>
                <div class="stake-content" v-if="joint.stakeAction === 'join'">
                  <div
                    class="stake-input-outer"
                    :class="`${$i18n.locale}-${
                      joint.activity.activity_available === 1
                        ? 'activity'
                        : 'normal'
                    }`"
                  >
                    <div
                      class="remaining"
                      v-if="joint.activity.activity_available === 1"
                    >
                      <span class="remaining-label">{{
                        $t("remainingAmount")
                      }}</span>
                      <span class="remaining-value">{{
                        `${joint.activity.activity_remain_mount} ETH`
                      }}</span>
                    </div>
                    <div
                      class="stake-input-wrap"
                      :class="{
                        'fix-margin': joint.activity.activity_available !== 1,
                      }"
                    >
                      <input
                        v-model="joint.stakeInputAmount"
                        :placeholder="$t('inputJointStakeAmount')"
                        class="stake-input"
                        @input="alterStakeInputAmount"
                        :disabled="!account || joint.transfering"
                      />
                      <span class="stake-unit">ETH</span>
                    </div>
                    <p class="stake-tip">{{ $t("jointStakeTip") }}</p>
                  </div>

                  <div class="stake-agree">
                    <img
                      class="stake-agree-check"
                      :src="
                        isDarkMode
                          ? require('../assets/checked-dark.png')
                          : require('../assets/checked.png')
                      "
                      v-if="joint.agreeChecked"
                      @click="joint.agreeChecked = false"
                    />
                    <div
                      class="stake-agree-uncheck"
                      v-else
                      @click="joint.agreeChecked = true"
                    ></div>
                    <span v-html="$t('aboutStake')"></span>
                  </div>
                  <button
                    type="button"
                    class="stake-confirm"
                    @click="submit"
                    :disabled="jointSubmitDisabled"
                  >
                    {{ overAccount ? $t("overAccount") : $t("pay") }}
                  </button>
                </div>
                <div class="unstake-content" v-else>
                  <div class="unstake-input-outer">
                    <div class="unstake-type-wrap unstake-type-wrap-mobile" v-if="joint.stakeAction === 'quit'">
                      <div class="unstake-btn" @click="onUnStakeType(0)">
                        <span :class="{ active: unstake_type === 0}">{{  $t('normalQuit') }}</span>
                        <div class="bottom-line" :class="{ show: unstake_type === 1 }"></div>
                      </div>
                      <div class="unstake-btn" @click="onUnStakeType(1)">
                        <span :class="{ active: unstake_type === 1}">{{ $t('fastQuit') }}</span>
                        <div class="bottom-line" :class="{ show: unstake_type === 0 }"></div>
                      </div>
                    </div>
                    <div class="unstake-tip-wrap">
                      <p class="unstake-tip" v-if="unstake_type === 0">
                        {{ `${$t("canQuitAmount")}${joint.staked || 0} ETH` }}
                      </p>
                      <p class="unstake-tip" v-else>
                        {{ `${$t("canFastQuitAmount")}${can_quit} ETH` }}
                      </p>
                      <div
                        v-if="unstake_type === 1"
                        class="question question-mobile"
                        :class="`question-${isDarkMode ? 'dark' : 'day'}`"
                        @click="joint.quitMaxOverview = true"
                      >
                        <div
                          v-show="joint.quitMaxOverview"
                          class="quit-max-overview"
                        >
                          <p>{{ `${$t("quitMax1")}${joint.dayLimit} ETH` }}</p>
                          <p>
                            {{
                              `${$t("quitMax2")}${joint.everyoneDayLimit} ETH`
                            }}
                          </p>
                          <p>
                            {{ `${$t("quitMax3")}${joint.staked || 0} ETH` }}
                          </p>
                          <p>{{ `${$t("quitMin")}0.1 ETH` }}</p>
                        </div>
                      </div>
                      <div
                        v-if="unstake_type === 1"
                        class="question question-pc"
                        :class="`question-${isDarkMode ? 'dark' : 'day'}`"
                        @mouseenter="joint.quitMaxOverview = true"
                        @mouseleave="joint.quitMaxOverview = false"
                      >
                        <div
                          v-show="joint.quitMaxOverview"
                          class="quit-max-overview"
                        >
                          <p>{{ `${$t("quitMax1")}${joint.dayLimit} ETH` }}</p>
                          <p>
                            {{
                              `${$t("quitMax2")}${joint.everyoneDayLimit} ETH`
                            }}
                          </p>
                          <p>
                            {{ `${$t("quitMax3")}${joint.staked || 0} ETH` }}
                          </p>
                          <p>{{ `${$t("quitMin")}0.1 ETH` }}</p>
                        </div>
                      </div>
                      <div
                        class="quit-max-overview-bg"
                        v-show="joint.quitMaxOverview"
                        @click="joint.quitMaxOverview = false"
                      ></div>
                    </div>
                    <div class="unstake-input-wrap">
                      <input
                        class="unstake-input"
                        v-model="joint.unstakeInputAmount"
                        :placeholder="$t('inputQuitAmount')"
                        @input="alterUnstakeInputAmount"
                      />
                      <span class="unstake-unit">ETH</span>
                    </div>
                    <div class="unstake-withdraw-wrap">
                      <div class="withdraw-left">
                        <span>{{ $t('withdrawAmount') }}</span>
                        <img @click="showModal(1)" v-if="isDarkMode" src="../assets/question-dark.png" alt=""/>
                        <img @click="showModal(1)" v-else src="../assets/question-day.png" alt=""/>
                        <span>: {{ joint.canWithdrawAmount }} ETH</span>
                      </div>
                      <input v-if="isTest" type="text" v-model="testCanWithdrawAmount" style="border: 1px solid #555; width: 50px">
                      <button 
                        type="button"
                        class="withdraw-btn" 
                        :class="{ disabled: joint.canWithdrawAmount == 0 }" 
                        @click="onWithdrawCapital"
                      >
                        {{ $t('withdraw') }}
                      </button>
                    </div>
                    <div class="handling-fee" v-if="unstake_type === 1">{{ $t('quitHandlingFee') }}</div>
                  </div>
                  <p class="unstake-about" v-html="$t('aboutUnstake')"></p>
                  <button
                    type="button"
                    class="unstake-submit"
                    @click="unstakeSubmit"
                    :disabled="jointUnstakeSubmitDisabled"
                  >
                    {{ $t("confirmQuit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="history-wrap as-page"
            :class="{
              [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
              open: joint.historyVisible,
            }"
          >
            <div class="mobile-stake-page-header">
              <span
                class="mobile-stake-page-back"
                @click="joint.historyVisible = false"
                >&lt;</span
              >
              <span class="mobile-stake-page-title">{{
                $t("stakeHistory")
              }}</span>
            </div>
            <div class="history-title-wrap">
              <span class="mobile-stake-page-title">{{
                $t("stakeHistory")
              }}</span>
              <img
                class="history-arrow"
                :src="
                  isDarkMode
                    ? require('../assets/arrow-dark.png')
                    : require('../assets/arrow-day.png')
                "
                @click="joint.historyVisible = false"
              />
            </div>
            <div class="history-list" v-if="joint.historyList.length">
              <div
                class="history-item"
                v-for="(item, index) in joint.historyList"
                :key="`joint-history-${index}`"
                @click="openExplorer(item)"
                :class="{ 'withdraw-arrow': item.unstake_type === -1 }"
              >
                <img
                  class="history-item-status"
                  :src="
                    item.status === 'staked'
                      ? require('../assets/stake.png')
                      : item.status === 'unstaked'
                      ? require('../assets/unstake.png')
                      : item.status === 'withdrawal'
                      ? require('../assets/withdraw.png')
                      : require('../assets/staking.png')
                  "
                />
                <div class="history-item-left">
                  <p class="history-item-title">
                    {{
                      item.unstake_type == -1 ? '' : item.unstake_type == 1 ? $t('quit') : $t('normal') 
                    }}{{ $i18n.locale === 'zh' ? $t(item.status) : (' ' + $t(item.status)) }}
                  </p>
                  <p class="history-item-time">
                    {{ item.op_time }}
                  </p>
                </div>
                <div class="history-item-right">
                  {{
                    `${
                      item.status === "staked" || item.status === "staking" || item.status === "deposit"
                        ? "-"
                        : "+"
                    } ${item.amount} ETH`
                  }}
                </div>
              </div>
            </div>
            <div class="history-no-data" v-else>
              <img
                :src="
                  isDarkMode
                    ? isMobileSize
                      ? require('../assets/no-history-dark.png')
                      : require('../assets/no-history-dark-pc.png')
                    : require('../assets/no-history-day.png')
                "
              />
              <p>{{ $t("noHistoryData") }}</p>
            </div>
          </div>
        </div>
        <div
          class="details-self-host"
          :class="$i18n.locale"
          v-show="statusType === 'selfHost'"
        >
          <div class="mobile-stake-page-header">
            <span
              class="mobile-stake-page-back"
              @click="
                mobileHidden = true;
                statusType = 'joint';
              "
              >&lt;</span
            >
            <span class="mobile-stake-page-title">{{
              $t("selfHostStake")
            }}</span>
          </div>
          <div class="details-overview">
            <div class="total-stake">
              <p class="label">{{ $t("totalStake") }}</p>
              <p class="value">{{ selfHost.staked }}</p>
              <div class="go-endpoint" @click="goEndpoint">
                <span>{{ $t('details') }}</span>
                <img v-if="isDarkMode" src="../assets/endpoint-arrow-dark.png" alt=""/>
                <img v-else src="../assets/endpoint-arrow.png" alt=""/>
              </div>
            </div>
            <div class="total-endpoint">
              <p class="label">{{ $t("endpointAmount") }}</p>
              <p class="value">{{ endpointAmount || "--" }}</p>
            </div>
            <div class="total-income">
              <p class="label">{{ `${$t("totalIncome")} (ETH)` }}</p>
              <p class="value">{{ self_host_total_reward || "--" }}</p>
            </div>
            <!-- <div class="go-endpoint" @click="goEndpoint">
              <span>查看详情</span>
              <img v-if="isDarkMode" src="../assets/endpoint-arrow-dark.png" alt=""/>
              <img v-else src="../assets/endpoint-arrow.png" alt=""/>
            </div> -->
            <div class="estimate-annualized">
              <p class="label">{{ $t("estimateAnnualized") }}</p>
              <div class="value-wrap">
                <p class="value">{{ selfHost.estimate_annualized || "--" }}</p>
                <div
                  class="self-host-btn"
                  @click="selfHost.stakeVisible = true"
                >
                  {{ $t("joinStake") }}
                </div>
              </div>
            </div>
          </div>
          <div class="details-content" :class="{ isPadding: statusType == 'selfHost'}">
            <div class="line-chart-wrap bar-chart-wrap">
              <div class="line-chart-info">
                <span class="line-chart-title">{{ $t("endpointIncome") }}</span>
              </div>
              <div id="bar-chart"></div>
            </div>
            <div class="details-right">
              <div class="details-right-top">
                <div
                  class="details-endpoint-status-wrap"
                  :class="{
                    open: selfHost.openBlock === 'endpoint',
                  }"
                >
                  <div
                    class="details-endpoint-status fold-wrap"
                    @click="
                      mobileInnerHidden = false;
                      selfHost.openBlock = 'endpoint';
                    "
                  >
                    {{ $t("endpointStatus") }}
                  </div>
                  <div
                    class="details-endpoint-status-content"
                    :class="{
                      'mobile-inner-hidden': mobileInnerHidden,
                      [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
                      'as-page': true,
                    }"
                    v-show="selfHost.openBlock === 'endpoint'"
                  >
                    <div class="mobile-stake-page-header">
                      <span
                        class="mobile-stake-page-back"
                        @click="mobileInnerHidden = true"
                        >&lt;</span
                      >
                      <span class="mobile-stake-page-title">{{
                        $t("endpointStatus")
                      }}</span>
                    </div>
                    <p class="mobile-endpoint-title">{{ $t("myEndpoints") }}</p>
                    <div
                      class="endpoint-wrap"
                      v-for="(item, index) in selfHost.endpointList"
                      :key="`endpoint-${index}`"
                    >
                      <div class="endpoint">
                        <div class="endpoint-title">
                          <span class="endpoint-name">{{
                            `${$t("endpont")} ${item.identifer}`
                          }}</span>
                          <span
                            class="endpoint-status"
                            :class="`endpoint-status-${item.status}`"
                          >
                            <div class="endpoint-status-point"></div>
                            <span class="endpoint-status-title">{{
                              $t(`endpointStatusMap.${item.status}`)
                            }}</span>
                          </span>
                        </div>
                        <div class="endpoint-stake-info">
                          <div class="endpoint-stake-amount">
                            <p class="endpoint-stake-label">
                              {{ `${$t("stakeAmount")}(ETH)` }}
                            </p>
                            <p class="endpoint-stake-value">
                              {{ item.amount || "--" }}
                            </p>
                          </div>
                          <div class="endpoint-stake-income">
                            <p class="endpoint-stake-label">
                              {{ `${$t("totalIncome")}(ETH)` }}
                            </p>
                            <p class="endpoint-stake-value">
                              {{ item.reward_visible || "--" }}
                            </p>
                          </div>
                          <div class="endpoint-stake-annualized">
                            <p class="endpoint-stake-label">
                              {{ $t("estimateAnnualized") }}
                            </p>
                            <p class="endpoint-stake-value">
                              {{
                                item.apr_visible ? `${item.apr_visible}%` : "--"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="endpoint-line">
                          <span class="endpoint-line-label">{{
                            $t("effectiveTime")
                          }}</span>
                          <span class="endpoint-line-value">
                            {{ getLocaleTime(item.effective_time) || validatorAlivePredictedHour }}
                          </span>
                        </div>
                        <div class="endpoint-line">
                          <div class="endpoint-line-left">
                            <span class="endpont-line-label">{{
                              $t("withdrawalAddress")
                            }}</span>
                            <!-- <img
                              :src="
                                isDarkMode
                                  ? require('../assets/question-dark.png')
                                  : require('../assets/question-day.png')
                              "
                            /> -->
                          </div>
                          <div class="endpoint-line-right">
                            <span class="endpoint-line-value">{{
                              addressParseOmit(item.address, 6, 6)
                            }}</span>
                            <img
                              :src="
                                isDarkMode
                                  ? require('../assets/copy-dark.png')
                                  : require('../assets/copy-day.png')
                              "
                              v-clipboard:copy="item.address"
                              v-clipboard:success="() => showToast(11)"
                            />
                          </div>
                        </div>
                        <div class="endpoint-unstake-line" v-if="item.status === 2">
                          <div class="button" @click="selfHostUnStake(item.identifer)">{{ $t('quitStake') }}</div>
                        </div>
                        <template v-if="item.status === 3 && item.node_exit_est_date">
                          <div class="line"></div>
                          <div class="endpoint-line receive-time">
                            <span class="endpoint-line-label">
                              {{$t("receiveTime")}}
                            </span>
                            <span class="endpoint-line-value">
                              {{ item.node_exit_est_date }}
                              {{ $i18n.locale === 'zh' ? '天' : item.node_exit_est_date > 1 ? 'days' : 'day' }}
                            </span>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div
                      class="endpoint-no-data"
                      v-if="!selfHost.endpointList.length"
                    >
                      <img
                        :src="
                          isDarkMode
                            ? isMobileSize
                              ? require('../assets/no-endpoint-dark.png')
                              : require('../assets/no-endpoint-dark-pc.png')
                            : require('../assets/no-endpoint-day.png')
                        "
                      />
                      <p>{{ $t("noEndpointData") }}</p>
                    </div>
                  </div>
                </div>
                <div
                  class="details-stake-history-wrap"
                  :class="{ open: selfHost.openBlock === 'history' }"
                >
                  <div
                    class="details-stake-history fold-wrap"
                    @click="
                      mobileInnerHidden = false;
                      selfHost.openBlock = 'history';
                    "
                  >
                    {{ $t("stakeHistory") }}
                  </div>
                  <div
                    class="details-stake-history-content"
                    :class="{
                      'mobile-inner-hidden': mobileInnerHidden,
                      [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
                      'as-page': true,
                    }"
                    v-show="selfHost.openBlock === 'history'"
                  >
                    <div class="mobile-stake-page-header">
                      <span
                        class="mobile-stake-page-back"
                        @click="mobileInnerHidden = true"
                        >&lt;</span
                      >
                      <span class="mobile-stake-page-title">{{
                        $t("stakeHistory")
                      }}</span>
                    </div>
                    <div
                      class="details-stake-history-item fold-wrap"
                      v-for="(item, index) in selfHost.stakeHistoryList"
                      :key="`self-host-stake-${index}`"
                      @click="openExplorer(item)"
                    >
                      <img src="../assets/stake.png" />
                      <div class="self-host-stake-left">
                        <!-- <div class="self-host-stake-title">
                          {{
                            item.active_amount ? $t("staked") : $t("staking")
                          }}
                        </div> -->
                        <div class="self-host-stake-title">
                          {{ item.type_text }}
                        </div>
                        <div class="self-host-stake-time">
                          {{ getLocaleTime(item.history_time) }}
                        </div>
                      </div>
                      <span class="self-host-stake-amount">{{
                        `${item.amount} ETH`
                      }}</span>
                    </div>
                    <div
                      class="details-stake-history-no-data"
                      v-if="!selfHost.stakeHistoryList.length"
                    >
                      <img
                        :src="
                          isDarkMode
                            ? isMobileSize
                              ? require('../assets/no-history-dark.png')
                              : require('../assets/no-history-dark-pc.png')
                            : require('../assets/no-history-day.png')
                        "
                      />
                      <p>{{ $t("noHistoryData") }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="details-right-bottom fold-wrap"
                @click="openUrl($t('selfHostCommonQuestionUrl'))"
              >
                {{ $t("commonQuestion") }}
              </div>
            </div>
          </div>
          <div
            class="history-wrap self-host-stake-wrap as-page"
            :class="{
              open: selfHost.stakeVisible,
              [`${isDarkMode ? 'mobile-dark' : 'mobile-day'}`]: true,
            }"
          >
            <div class="history-title-wrap">
              <span
                class="history-title-wrap-back"
                @click="selfHost.stakeVisible = false"
                >&lt;</span
              >
              <span class="history-title">{{ $t("joinStake") }}</span>
              <img
                class="history-arrow"
                :src="
                  isDarkMode
                    ? require('../assets/arrow-dark.png')
                    : require('../assets/arrow-day.png')
                "
                @click="selfHost.stakeVisible = false"
              />
            </div>
            <div class="inner-stake-user-status">
              <img src="../assets/eth-mobile.png" />
              <span class="inner-stake-user-address">{{
                addressParseOmit(account, 5, 5)
              }}</span>
              <div class="inner-stake-user-right">
                <p class="inner-stake-user-value">
                  {{ `${balance_display} ETH` }}
                </p>
                <p class="inner-stake-user-label">
                  {{ $t("balance") }}
                </p>
              </div>
            </div>
            <div class="self-host-stake-block self-host-stake-block1">
              <div class="self-host-stake-warn">
                <img
                  :src="
                    isDarkMode
                      ? require('../assets/warn-orange-dark.png')
                      : require('../assets/warn-orange-day.png')
                  "
                />
                <span>{{ $t("selfHostStakeWarn") }}</span>
              </div>
              <div class="self-host-stake-endpoint-amount">
                <span class="self-host-stake-endpoint-amount-title">{{
                  $t("endpointCount")
                }}</span>
                <div class="self-host-stake-endpoint-amount-right">
                  <button
                    class="minus"
                    type="button"
                    :disabled="selfHost.endpointAmount <= 1"
                    @click="selfHost.endpointAmount--"
                  >
                    <span>-</span>
                  </button>
                  <div class="amount">{{ selfHost.endpointAmount }}</div>
                  <button
                    class="plus"
                    type="button"
                    :disabled="selfHost.endpointAmount >= 100"
                    @click="selfHost.endpointAmount++"
                  >
                    <span>+</span>
                  </button>
                </div>
              </div>
              <div class="need-balance">
                <span class="need-balance-label">{{
                  $t("needToStakeAmount")
                }}</span>
                <span class="need-balance-value">{{
                  `${selfHost.endpointAmount * 32} ETH`
                }}</span>
              </div>
            </div>
            <p class="self-host-stake-title">{{ $t("feeDetails") }}</p>
            <div class="self-host-stake-block self-host-stake-block2">
              <div class="self-host-stake-item">
                <span class="self-host-stake-item-label">{{
                  $t("endpointStake")
                }}</span>
                <span class="self-host-stake-item-right">{{
                  `32 ETH/${$t("one")}`
                }}</span>
              </div>
              <div class="self-host-stake-item">
                <span class="self-host-stake-item-label">{{
                  $t("amount")
                }}</span>
                <span class="self-host-stake-item-right">{{
                  `${selfHost.endpointAmount}${
                    $i18n.locale === "zh" ? $t("one") : ""
                  }`
                }}</span>
              </div>
              <div class="self-host-stake-item">
                <span class="self-host-stake-item-label">{{
                  $t("endpointMaintainFee")
                }}</span>
                <div class="self-host-stake-item-right">
                  <span class="self-host-stake-item-value">{{
                    `${selfHostStakeFee} (${$t("forever")})`
                  }}</span>
                  <div
                    class="self-host-stake-item-question mobile"
                    @click="endpointTipVisible = true"
                  >
                    <div
                      class="self-host-stake-item-question-tip"
                      v-show="endpointTipVisible"
                    >
                      {{ $t("endpointFeeTip") }}
                    </div>
                  </div>
                  <div
                    class="self-host-stake-item-question pc"
                    @mouseenter="endpointTipVisible = true"
                    @mouseleave="endpointTipVisible = false"
                  >
                    <div
                      class="self-host-stake-item-question-tip"
                      v-show="endpointTipVisible"
                    >
                      {{ $t("endpointFeeTip") }}
                    </div>
                  </div>
                  <div
                    class="self-host-stake-item-question-tip-bg"
                    v-show="endpointTipVisible"
                    @click="endpointTipVisible = false"
                  ></div>
                </div>
              </div>
              <div
                class="self-host-stake-keypal"
                @click="
                  keypalInfo.selectedCountryCode = countryCode;
                  keypalVisible = true;
                "
              >
                <div class="self-host-stake-keypal-left">
                  <img
                    :src="
                      isDarkMode
                        ? require('../assets/keypal-dark.png')
                        : require('../assets/keypal-day.png')
                    "
                  />
                  <span>{{ $t("sendKeypal") }}</span>
                </div>
                <div class="self-host-stake-keypal-right">
                  <span>{{
                    omitAddressDetails ? omitAddressDetails : $t("editAddress")
                  }}</span>
                  <span class="arrow">&gt;</span>
                </div>
              </div>
              <div class="self-host-stake-split"></div>
              <div class="self-host-stake-item">
                <span class="self-host-stake-item-label">{{
                  $t("totalFee")
                }}</span>
                <div class="self-host-stake-item-content">
                  <p class="self-host-stake-item-cal">
                    {{ `32x${selfHost.endpointAmount} + ${selfHostStakeFee}` }}
                  </p>
                  <p class="self-host-stake-item-sum">
                    {{ `= ${selfHostStakeAmount} ETH` }}
                  </p>
                </div>
              </div>
            </div>
            <div class="self-host-stake-pay-wrap">
              <div class="self-host-stake-agree-wrap">
                <img
                  class="self-host-stake-agree-check"
                  :src="
                    isDarkMode
                      ? require('../assets/checked-dark.png')
                      : require('../assets/checked.png')
                  "
                  v-if="selfHost.agreeChecked"
                  @click="selfHost.agreeChecked = false"
                />
                <div
                  class="self-host-stake-agree-uncheck"
                  v-else
                  @click="selfHost.agreeChecked = true"
                ></div>
                <span v-html="$t('aboutStake')"></span>
              </div>
            </div>
            <button
              type="button"
              class="self-host-stake-confirm"
              @click="selfHostSubmit"
              :disabled="selfHostSubmitDisabled"
            >
              {{ selfHostOverAccount ? $t("overAccount") : $t("pay") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="self-host-stake-keypal-cover" v-if="keypalVisible">
      <div class="self-host-stake-keypal-popover">
        <div class="self-host-stake-keypal-popover-header">
          <span class="self-host-stake-keypal-popover-title">{{
            $t("editAddress")
          }}</span>
          <img
            :src="
              isDarkMode
                ? require('../assets/settings-close-dark.png')
                : require('../assets/settings-close-day.png')
            "
            @click="resetKeypalInfo"
          />
        </div>
        <div class="self-host-stake-keypal-popover-item">
          <p><span class="necessary">*</span>{{ $t("receivePerson") }}</p>
          <input :placeholder="$t('name')" v-model="keypalInfo.address" />
        </div>
        <div class="self-host-stake-keypal-popover-item">
          <p><span class="necessary">*</span>{{ $t("phoneNumber") }}</p>
          <div class="phone-wrap">
            <div class="country-code-wrap">
              <div
                class="country-code"
                @click="countryCodeVisible = !countryCodeVisible"
              >
                <span class="country-code-name">{{
                  `${
                    $i18n.locale === "zh"
                      ? keypalInfo.selectedCountryCode.cn
                      : keypalInfo.selectedCountryCode.en
                  } ${keypalInfo.selectedCountryCode.phone_code}`
                }}</span>
                <div class="country-code-expand">
                  <div class="country-code-expand1">&lt;</div>
                  <div class="country-code-expand2">&gt;</div>
                </div>
              </div>
            </div>
            <div class="phone-split"></div>
            <input
              :placeholder="$t('inputPhoneNumber')"
              v-model="keypalInfo.phone"
              type="number"
            />
            <div class="country-code-list-wrap" v-show="countryCodeVisible">
              <div class="country-code-list">
                <div
                  class="country-code-list-item"
                  v-for="(item, index) in countryCodeList"
                  :key="`country-${index}`"
                  @click="
                    keypalInfo.selectedCountryCode = item;
                    countryCodeVisible = false;
                  "
                >
                  {{
                    `${$i18n.locale === "zh" ? item.cn : item.en} ${
                      item.phone_code
                    }`
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="self-host-stake-keypal-popover-item">
          <p>{{ $t("email") }}</p>
          <input v-model="keypalInfo.email" placeholder="example@domain.com" />
        </div>
        <div class="self-host-stake-keypal-popover-item">
          <p><span class="necessary">*</span>{{ $t("emailCode") }}</p>
          <input
            placeholder="000000"
            v-model="keypalInfo.emailCode"
            type="number"
          />
        </div>
        <div class="self-host-stake-keypal-popover-item">
          <p><span class="necessary">*</span>{{ $t("addressDetails") }}</p>
          <textarea
            :placeholder="$t('addressDetails')"
            v-model="keypalInfo.addressDetails"
          />
        </div>
        <button
          type="button"
          @click="setPrevKeypalInfo"
          :disabled="keypalConfirmDisabled"
        >
          {{ $t("confirm") }}
        </button>
      </div>
    </div>
    <Toast v-if="isToast" :title="toastTitle" :toastType="toastType" />
    <Modal v-if="isModal" :modalTextData="modalTextData" @closeModal="closeModal"/>
  </div>
</template>

<script>
import tp from "tp-js-sdk";
import Switcher from "./Switcher.vue";
import { ethers } from "ethers";
const Web3 = require("web3");
import axios from "../utils/axios.js";
import kele_axios from "../utils/kele_axios.js";
import echarts from "echarts";
import BigNumber from "bignumber.js";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import countryCodeList from "../country-code.js";
import { v4 as uuidv4 } from 'uuid';
import Toast from './Toast.vue';
import Modal from './Modal.vue';

import { ABI } from '../utils/abi'
import { OLD_ABI } from '../utils/old_abi'
import { computeNumber, secondsToDays, convertToDecimal } from "../utils";
import { onboard } from "../utils/onboard";
// console.log('onboard', onboard);

const COMMON_API = "/v1/pledge/method_any_v2";

// const userAgent = window.navigator.userAgent;
// const isAndroid =
//   userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
// if (isAndroid) {
//   tp.fullScreen({
//     fullScreen: 1,
//   });
// }

export default {
  name: "StakeVault",
  components: {
    Switcher,
    Toast,
    Modal,
  },
  data() {
    return {
      unsubscribe: {},
      isTest: false, // 打开测试可输入金额
      toastTitle: '',
      toastType: 0,
      estimateGas: 0,
      testWithdrawAmount: 0,
      testCanWithdrawAmount: 0,
      unstake_type: 0,
      sub_uid: '',
      isToast: false,
      isModal: false,
      modalType: 0,
      isTP: false,
      web3: null,
      evmProvider: null,
      isDarkMode: false,
      localeMenuVisible: false,
      statusType: "joint",
      account: "",
      connected: {
        chainId: "",
        account: "",
      },
      isETH: false,
      joint: {
        withdrawIncomeAmount: 0, // 可提现的收益
        canWithdrawAmount: 0, // 总可提现余额（本金+收益）
        staked: 0,
        totalStaked: 0,
        total_reward: null,
        estimate_annualized: null,
        stakeAction: "join",
        stakeDateStr: "",
        unStakingCount: 0,
        stakeInputAmount: "",
        unstakeInputAmount: "",
        agreeChecked: false,
        activity: {
          balance: 0,
          activity_remain_mount: 0,
          activity_available: 0,
        },
        transfering: false,
        hash: "",
        historyVisible: false,
        historyList: [],
        dayLimit: 0,
        everyoneDayLimit: 0,
        unstakeTransfering: false,
        quitMaxOverview: false,
        jointStakeInfoInterval: null,
        confirming_count: 0,
        confirmed_amount: 0,
      },
      selfHost: {
        staked: 0,
        total_reward: null,
        estimate_annualized: null,
        endpointList: [],
        openBlock: "endpoint",
        stakeHistoryOpen: false,
        stakeHistoryList: [],
        stakeVisible: false,
        endpointAmount: 1,
        agreeChecked: false,
        incomeList: [],
        mevIncomeList: [],
        transfering: false,
        orderId: null,
      },
      balance: 0,
      chart: {
        lineChart: null,
        xAxis: [],
        yAxis: [],
        interval: "day",
        xAxis0: null,
        hasData: false,
        noAsset: false,
        option: {},
        labelColor: "#72777b",
        lineColor: "#f2f3f7",
        noDataColor: "#9ea0a5",
      },
      selfHostChart: {
        barChart: null,
        hasData: false,
        noAsset: false,
        option: {},
        tooltipBg: "#ffffff",
        splitLineColor: "#e7eaee",
        shadowBg: "rgba(128, 128, 128, 0.1)",
        totalColor: "#3a3b3d",
      },
      toastMsg: "",
      localeList: [
        {
          value: "en",
          label: "English",
        },
        {
          value: "zh",
          label: "简体中文",
        },
      ],
      mobileHidden: true,
      isMobileSize: false,
      mobileInnerHidden: true,
      settingsVisible: false,
      hasCreateBarChart: false,
      keypalVisible: false,
      keypalInfo: {
        address: "",
        addressDetails: "",
        emailCode: "",
        phone: "",
        selectedCountryCode: {},
        email: "",
      },
      prevKeypalInfo: {
        address: "",
        addressDetails: "",
        emailCode: "",
        phone: "",
        selectedCountryCode: {},
        email: "",
      },
      countryCodeList,
      countryCodeVisible: false,
      endpointTipVisible: false,
      downloadVisible: false,
      validator_alive_predicted_hour: '', // 现在质押后，多少小时后生效 (单位: 小时)
      page_number: 1,
      page_size: 20,
    };
  },
  computed: {
    endpointAmount() {
      let eList = JSON.parse(JSON.stringify(this.selfHost.endpointList))
      let eArr = []
      eArr = eList.filter(item => item.status !== 5)
      return eArr.length
    },
    jointSelfHostTotalStaked() {
      return computeNumber(Number(this.selfHost.staked), '+', Number(this.joint.totalStaked)).result
    },
    validatorAlivePredictedHour() {
      /**
       * 大于1天： 预计xx天xx小时后生效  To be active in xx day xx hours
         小于1天，大于1小时：预计xx小时后生效 To be active in xx hours
         小于1小时：预计1小时内生效 To be active in an hour
       */
      let hours = this.validator_alive_predicted_hour
      let lang = this.$i18n.locale
      if (hours) {
        if (hours >= 24) {
          var days = Math.floor(hours / 24);
          var remainingHours = hours % 24;
          if (lang === 'zh') {
            if (remainingHours > 0) {
              return "预计" + days + "天" + remainingHours + "小时后生效";
            } else {
              return "预计" + days + "天" + "后生效";
            }
          } else {
            let dayStr = days > 1 ? 'days' : 'day'
            let hourStr = remainingHours > 1 ? 'hours' : 'hour'
            if (remainingHours > 0) {
              return 'To be active in ' + days + " " + dayStr + " " + remainingHours + " " + hourStr
            } else {
              return 'To be active in ' + days + " " + dayStr
            }
          }
        } else if (hours > 1) {
          if (lang === 'zh') {
            return "预计" + hours + "小时后生效";
          } else {
            let hourStr = hours > 1 ? 'hours' : 'hour'
            return 'To be active in ' + hours + " " + hourStr
          }
        } else {
          if (lang === 'zh') {
            return "预计1小时内生效";
          } else {
            return 'To be active in an hour'
          }
        }
      } else {
        return '--'
      }
    },
    curStatusType() {
      return {jointStaked: this.joint.staked}
    },
    modalTextData() {
      return {
        title: this.$t(`modalTextData.title_${this.modalType + 1}`),
        desc: this.$t(`modalTextData.desc_${this.modalType + 1}`),
        btn: this.$t(`modalTextData.btn_${this.modalType + 1}`),
      }
    },
    joint_total_reward() {
      return this.joint.total_reward || '0';
    },
    self_host_total_reward() {
      if (!this.selfHost.total_reward) {
        return null;
      }
      return new BigNumber(this.selfHost.total_reward).toFixed(6, 1)
    },
    jointAndSelfHostTotalReward() {
      if (!this.joint_total_reward && !this.selfHost.total_reward) {
        return 0
      } else {
        let x = new BigNumber(this.joint.total_reward)
        let y = x.plus(this.selfHost.total_reward).toString()
        if (isNaN(y)) {
          return 0
        } else {
          return y
        }
      }
      // return this.truncateDecimals(this.joint_total_reward + this.selfHost.total_reward, 8)
    },
    balance_display() {
      let balance = this.balance.toString();
      const index = balance.indexOf(".");
      if (index !== -1) {
        balance = balance.substring(0, index + 5);
      }
      return balance;
    },
    overAccount() {
      return Number(this.balance) < Number(this.joint.stakeInputAmount);
    },
    allowAmount() {
      let amount = 0.1
      if (this.isTest) {
        amount = 0.01
      }
      return amount
    },
    underJointUnstakeAccount() {
      return Number(this.joint.unstakeInputAmount) < this.allowAmount;
    },
    overJointUnstakeAccount() {
      if (this.unstake_type === 0) {
        return Number(this.joint.unstakeInputAmount) > Number(this.joint.staked);
      } else {
        return Number(this.joint.unstakeInputAmount) > Number(this.can_quit);
      }
    },
    jointSubmitDisabled() {
      return (
        !this.account ||
        !this.joint.agreeChecked ||
        !this.joint.stakeInputAmount ||
        this.overAccount ||
        this.joint.transfering
      );
    },
    jointUnstakeSubmitDisabled() {
      return (
        !this.account ||
        !this.joint.unstakeInputAmount ||
        this.overJointUnstakeAccount ||
        this.underJointUnstakeAccount ||
        this.joint.unstakeTransfering
      );
    },
    selfHostSubmitDisabled() {
      return (
        !this.account ||
        !this.selfHost.agreeChecked ||
        !this.selfHost.endpointAmount ||
        this.selfHost.transfering ||
        this.selfHostOverAccount
      );
    },
    selfHostOverAccount() {
      return (
        Number(this.balance) <
        parseFloat(
          BigNumber(32.05).times(BigNumber(this.selfHost.endpointAmount))
        )
      );
    },
    day_limit() {
      return Math.min(this.joint.dayLimit, this.joint.everyoneDayLimit);
    },
    can_quit() {
      return Math.min(this.day_limit, this.joint.staked || 0);
    },
    deposit_credentials() {
      if (this.account) {
        return "010000000000000000000000" + this.account.substring(2);
      } else {
        return "";
      }
    },
    selfHostStakeFee() {
      return BigNumber(0.05)
        .times(this.selfHost.endpointAmount)
        .plus(0.05)
        .toString();
    },
    selfHostStakeAmount() {
      return BigNumber(32.05)
        .times(BigNumber(this.selfHost.endpointAmount))
        .plus(0.05)
        .toString();
    },
    clonedConnected() {
      return JSON.parse(JSON.stringify(this.connected));
    },
    keypalConfirmDisabled() {
      let disabled = false;
      for (let key in this.keypalInfo) {
        if (!this.keypalInfo[key] && key !== "email") {
          disabled = true;
        }
      }
      return disabled;
    },
    omitAddressDetails() {
      if (this.prevKeypalInfo.addressDetails) {
        return this.prevKeypalInfo.addressDetails.substring(0, 5) + "...";
      }
    },
    defaultCountryCode() {
      const locale = this.$i18n.locale;
      return locale === "zh"
        ? { cn: "中国", en: "China", phone_code: "+86" }
        : { cn: "美国", en: "United States", phone_code: "+1" };
    },
    countryCode() {
      return this.keypalInfo.selectedCountryCode.phone_code
        ? this.keypalInfo.selectedCountryCode
        : this.defaultCountryCode;
    },
  },
  watch: {
    curStatusType() {
      if (this.joint.staked === 0 && Number(this.selfHost.staked) > 0) {
        this.statusType = 'selfHost'
      } else {
        this.statusType = 'joint'
      }
    },
    isDarkMode(val) {
      // console.log(val);
      localStorage.setItem("darkmode", val ? "1" : "0");
      if (val) {
        document.documentElement.setAttribute("theme", "dark");
        onboard.state.actions.updateTheme('dark')
        this.chart.labelColor = "#a8adb8";
        this.chart.lineColor = "#484b52";
        this.chart.noDataColor = "#71747a";
        this.selfHostChart.tooltipBg = "#2f2f33";
        this.selfHostChart.splitLineColor = "#484b52";
        this.selfHostChart.shadowBg = "rgba(128, 128, 128, 0.2)";
        this.selfHostChart.totalColor = "#ffffff";
      } else {
        document.documentElement.removeAttribute("theme");
        onboard.state.actions.updateTheme('light')
        this.chart.labelColor = "#72777b";
        this.chart.lineColor = "#e7eaee";
        this.chart.noDataColor = "#9ea0a5";
        this.selfHostChart.tooltipBg = "#ffffff";
        this.selfHostChart.splitLineColor = "#e7eaee";
        this.selfHostChart.shadowBg = "rgba(128, 128, 128, 0.1)";
        this.selfHostChart.totalColor = "#3a3b3d";
      }
      this.drawChart();
      if (this.selfHostChart.barChart) {
        this.drawBar();
      }
    },
    "chart.interval"(val) {
      this.getKLine().then((res) => {
        this.drawChart();
      });
    },
    mobileHidden(val) {
      if (this.isMobileSize) {
        document.body.style.overflow = val ? "auto" : "hidden";
      }
    },
    settingsVisible(val) {
      if (this.isMobileSize) {
        document.body.style.overflow = val ? "hidden" : "auto";
      }
    },
    isMobileSize(val) {
      if (!val) {
        document.body.style.overflow = "auto";
      } else {
        document.body.style.overflow = this.mobileHidden ? "auto" : "hidden";
      }
      this.$nextTick(() => {
        this.drawChart();
        if (this.selfHostChart.barChart) {
          this.drawBar();
        }
      });
    },
    statusType(val) {
      if (val === "selfHost" && !this.hasCreateBarChart) {
        this.hasCreateBarChart = true;
        this.$nextTick(() => {
          this.selfHostChart.barChart = echarts.init(
            document.getElementById("bar-chart")
          );
          this.drawBar();
        });
      }
    },
    clonedConnected: {
      handler(val, oldVal) {
        if (oldVal.account && val.account && oldVal.account !== val.account) {
          this.resetInfo();
        }
        if (val.chainId === process.env.VUE_APP_CHAIN_ID) {
          this.account = val.account;
        } else {
          this.account = "";
        }
      },
      deep: true,
    },
    account(val) {
      if (val) {
        this.setInfo();
        this.setSelfHostInfo();
      }
    },
  },
  created() {
    this.getSelfHostGlobal()
    this.isMobileSize = document.documentElement.clientWidth <= 700;
    window.onresize = () => {
      this.isMobileSize = document.documentElement.clientWidth <= 700;
      this.chart.lineChart.resize();
      if (this.selfHostChart.barChart) {
        this.selfHostChart.barChart.resize();
      }
    };
    if (localStorage.getItem("darkmode")) {
      this.isDarkMode = localStorage.getItem("darkmode") === "1";
    }
    tp.isDarkMode().then((res) => {
      this.isDarkMode = Boolean(res.data);
    });
    if (localStorage.getItem("locale")) {
      this.$i18n.locale = localStorage.getItem("locale");
    }
    this.getActivityInfo();
    this.getSelfHostDashboard("apr");
  },
  mounted() {
    if (process.env.VUE_APP_TEST_VALUE == 0) {
      this.isTest = true
    } else {
      this.isTest = false
    }
    this.showUpgradeModal()
    this.$nextTick(() => {
      this.selfHostHistoryContent()
    })
    // this.getEstimateGas()
    this.chart.lineChart = echarts.init(document.getElementById("line-chart"));
    this.chart.lineChart.resize()
    this.drawChart();
    if (navigator.userAgent.indexOf("TokenPocket") > -1) {
      this.initETH();
    } else {
      this.walletSubscribe()
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    selfHostHistoryContent() {
      const historyNode = document.querySelector('.details-stake-history-content')
      if (historyNode) {
        historyNode.onscroll = (e) => {
          if ((e.target.scrollTop + e.target.clientHeight) == e.target.scrollHeight) {
            this.getSelfHostHistory(this.page_number, this.page_size)
          }
        }
      }
    },
    goEndpoint() {
      this.mobileInnerHidden = false;
      this.selfHost.openBlock = 'endpoint';
    },
    /** ETH质押宝将于北京时间5月22日9:00PM到5月23日2:00AM进行系统升级,这个时间段内弹框提示用户 */
    showUpgradeModal() {
      const startTime = '1684758600000' // 2023-05-22 20:30:00
      const endTime = '1684814400000' // 2023-05-23 12:00:00
      const curTimestamp = Date.now()
      // console.log('startTime---', startTime);
      // console.log('curTimestamp', curTimestamp);
      if (curTimestamp >= startTime && curTimestamp <= endTime) {
        this.modalType = 2
        this.showModal(2)
        return true
      } else {
        return false
      }
    },
    /** 联合质押直接通过合约调用来质押 */
    async stakeByContract() {
      const isUpgrade = this.showUpgradeModal()
      if (isUpgrade) {
        return
      }
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner();
        let userAddress = await signer.getAddress();
        // 初始化合约参数
        const kelepool = {
          address: process.env.VUE_APP_KELE_CONTRACT,
          abi: OLD_ABI
        };
        const contract = new ethers.Contract(kelepool.address, kelepool.abi, signer);
        // 执行合约小额质押方法，最低质押0.01 ETH，这里我们质押125.0172ETH
        let amount = ethers.utils.parseUnits(this.joint.stakeInputAmount, 'ether')
  
        // 以下是V2版本（推荐使用），可以传递source渠道参数。
        // source渠道参数是可乐矿池分配给第三方渠道的标识，用于分红统计时区分是哪个渠道过来的质押金额。
        // 如果你之前接入了V1版本也没关系，更新成V2版本后，用户质押完成会优先写入从合约传递过来的source。
        let source = ethers.utils.arrayify(ethers.utils.formatBytes32String("tpsmall"))
        const tx = await contract.depositV2(source,{
            from: userAddress, // 调用者账号
            value: amount,// 质押金额
        });
  
        if (tx.hash) {
          // console.log(`小额质押交易哈希: ${tx.hash}`);
          this.showToast(7);
          provider.waitForTransaction(tx.hash).then(receipt => {
            // console.log('receipt', receipt);
            this.setInfo()
          })
        }
      } catch (error) {
        console.log(error);
        this.showToast(6);
      }
      this.joint.transfering = false;
    },

    /** 获取当前gas费 */
    getEstimateGas() {
      axios.get(`/v1/block_chain/fee_list?blockchain_id=1`).then(res => {
        let weiValue = (res?.data?.data?.fee_list[1]?.fee) * 21000 || 0
        let web3 = new Web3()
        this.estimateGas = this.truncateDecimals(web3.utils.fromWei(String(weiValue), 'ether'),8)
        // console.log('estimateGas', this.estimateGas);
      })
    },
    /** 获取当前gas费从可乐接口 */
    getEstimateGasFromKele() {
      axios.get(`/v1/pledge/method_any_v1`, 
        {
          params: {
            address: this.account,
          },
          headers: {
            api: '/eth2/v2/miner/withdrawal'
          },
        }
      ).then(res => {
        if (res.data && 
          res.data.result === 0 &&
          res.data.data && 
          res.data.data.code === 0
        ) {
          this.estimateGas = this.truncateDecimals(res.data.data.data.user_fee, 8)
        }
      }).catch(err => {
        console.log(err);
      })
    },
    onUnStakeType(type) {
      this.unstake_type = type
    },
    /** 获取账户的 sub_uid */
    async getSubUid(account) {
      return new Promise((resolve,reject) => {
        axios.get(`/v1/pledge/method_any_v1`,
          {
            params: {
              source: 'tokenpocket',
              third_uid: account,
            },
            headers: {
              api: '/eth2/v1/subminer'
            }
          }
        ).then(res=> {
          if (res.data && 
            res.data.result === 0 && 
            res.data.data && 
            res.data.data.data && 
            res.data.data.code === 0 
          ) {
            this.sub_uid = res.data.data.data.sub_uid
            resolve()
          }
        }).catch(err => {
          console.log(err);
        })
      })
    },

    /** 钱包签名 */
    async walletSign(amount, type, api, params) {
      const isUpgrade = this.showUpgradeModal()
      if (isUpgrade) {
        return
      }
      const n = amount.length - amount.indexOf(".") - 1;
      let amount_gwei = Math.round(Number(amount) * Math.pow(10, n)) * Math.pow(10, 9 - n);
      amount_gwei = parseInt(amount_gwei)
      // console.log('amount_gwei', amount_gwei);
      const order_id = uuidv4()
      try {
        let api_params = {}
        if (type === 3) { // 大额赎回
          api_params =  params
        } else { // 小额赎回、提现、提现收益
          api_params = {
            sub_uid: this.sub_uid,
            amount_gwei: amount_gwei,
            order_id: order_id,
            source: "tokenpocket",
          }
          if (type === 0) {
            api_params.unstake_type = this.unstake_type
          }
        }
        let sign_time = Math.floor(new Date().getTime() / 1000)
        let signMessage = {
          sign_time: sign_time,
          token: 'eth',
          addr: this.account,
          url: api,
          method: 'post',
          api_param: api_params
        }
        // console.log('signMessage', signMessage);
        let signMessage1 = JSON.stringify(signMessage)
        
        const from = this.account
        const msg = `0x${Buffer.from(signMessage1, 'utf8').toString('hex')}`
        // console.log('msg', msg);
        let provider = this.evmProvider || window.ethereum
        const sign = await provider.request({
          method: 'personal_sign',
          params: [msg, from],
        })
        // console.log('signMessage1', signMessage1);
        // console.log('sign', sign);
        if (type === 0) {
          // 小额质押赎回
          this.unStake(sign, signMessage1, String(amount_gwei), sign_time, this.unstake_type, order_id)
          // this.unStakeV2(sign, signMessage1)
        } else if (type === 1) {
          // 小额质押提现本金
          this.withdrawCapital(sign, signMessage1)
        } else if (type === 2) {
          // 小额质押提取收益
          this.withdrawReward(sign, signMessage1)
        } else if (type === 3) {
          // 大额质押赎回
          this.sendSelfHostUnStake(sign, signMessage1)
          // this.cover(sign, signMessage1)
          // this.cover(signMessage1)
        }
      } catch (err) {
        this.joint.unstakeTransfering = false
        console.error('err', err)
      }
    },
    /** 签名验证 */
    cover(sign,signMessage1){
      let address = this.web3.eth.accounts.recover(signMessage1, sign);
      console.log('address', address);
    },

    /**  发送提取本金请求 */
    withdrawCapital(sign, signMessage) {
      this.toastType = 1
      axios.post(`v1/pledge/method_any_v1`, 
        {
          _pirv_sign_raw: signMessage
        },
        {
          headers: {
            'Kele-Private-Sign': sign,
            api: '/eth2/v1/subminer/withdraw_v2'
          },
        }
      ).then(res => {
        if (res.data && 
          res.data.result === 0 &&
          res.data.data && 
          res.data.data.code === 0
        ) {
          this.setInfo()
          this.toastTitle = this.$t('withdrawSuccess')
          this.showWithdrawToast()
        }
      }).catch(() => {
        this.toastTitle = this.$t('withdrawFailed')
        this.showWithdrawToast()
      })
    },
    /** /v1/pledge/method_any_v1调用赎回接口 */
    unStakeV2(sign, signMessage) {
      axios.post(`/v1/pledge/method_any_v1`, 
        {
          _pirv_sign_raw: signMessage
        },
        {
          headers: {
            'Kele-Private-Sign': sign,
            api: '/eth2/v1/subminer/unstake_v2'
          },
        }
      ).then(res => {
        console.log('res', res);
      }).catch(err=>{
        console.log(err);
      })
    },
    /** 发送提取收益请求 */
    withdrawReward(sign, signMessage) {
      this.toastType = 1
      axios.post(`/v1/pledge/method_any_v1`, 
        {
          _pirv_sign_raw: signMessage
        },
        {
          headers: {
            'Kele-Private-Sign': sign,
            api: '/eth2/v1/subminer/withdraw_reward_v2'
          },
        }
      ).then(res => {
        if (res.data && 
          res.data.result === 0 &&
          res.data.data && 
          res.data.data.code === 0
        ) {
          this.setInfo()
          this.toastTitle = this.$t('withdrawSuccess')
          this.showWithdrawToast()
        }
      }).catch(err=>{
        this.toastTitle = this.$t('withdrawFailed')
        this.showWithdrawToast()
        console.log(err);
      })
    },
    /** 获取可提现本金、收益 */
    getPledgeSubminerAsset(sub_uid) {
      return new Promise((resolve, reject) => {
        axios.get(`/v1/pledge/method_any_v1`, 
          {
            params: {
              sub_uid: sub_uid
            },
            headers: {
              api: '/eth2/v1/subminer/asset'
            },
          }
        ).then(res => {
          if (res.data &&
            res.data.result === 0 &&
            res.data.data && 
            res.data.data.code === 0 
          ) {
            resolve(res.data.data.data)
          } else {
            reject();
          }
        })
      });
    },

    showModal(type) {
      this.modalType = type
      this.isModal = true
    },
    /** 提现本金 */
    onWithdrawCapital() {
      if (this.isTest) {
        if (this.testCanWithdrawAmount) {
          this.walletSign(String(this.testCanWithdrawAmount), 1, '/eth2/v1/subminer/withdraw_v2')
        }
      } else {
        if (this.joint.canWithdrawAmount) {
          this.walletSign(String(this.joint.canWithdrawAmount), 1, '/eth2/v1/subminer/withdraw_v2')
        }
      }
    },
    /** 提现收益 */
    onWithdrawReward() {
      // 为了方便测试提现收益，如果是测试就可以输入提现金额
      if (this.isTest) {
        // 测试可输入金额
        if (this.testWithdrawAmount < this.estimateGas) {
          this.toastTitle = this.$t('withdrawTips')
          this.showWithdrawToast()
          return
        }
        if (this.testWithdrawAmount) {
          this.walletSign(String(this.testWithdrawAmount), 2, '/eth2/v1/subminer/withdraw_reward_v2')
        }
      } else {
        // 提现金额大于当前预估的gas费的时候提示用户
        if (this.joint.realWithdrawIncomeAmount < this.estimateGas) {
          this.toastTitle = this.$t('withdrawTips')
          this.showWithdrawToast()
          return
        }
        if (this.joint.realWithdrawIncomeAmount) {
            this.walletSign(String(this.joint.realWithdrawIncomeAmount), 2, '/eth2/v1/subminer/withdraw_reward_v2')
        }
      }
    },
    showWithdrawToast() {
      if (!this.isToast) {
        this.isToast = true;
        setTimeout(() => {
          this.isToast = false;
        }, 2000);
      }
    },
    closeModal() {
      this.isModal = false
    },
    switchLocale(locale) {
      this.$i18n.locale = locale;
      this.localeMenuVisible = false;
      localStorage.setItem("locale", this.$i18n.locale);
      // 设置 walletconnect 语言
      onboard.state.actions.setLocale(locale)
      this.drawChart();
      if (this.selfHostChart.barChart) {
        this.drawBar();
      }
    },
    initETH() {
      try {
        if (navigator.userAgent.indexOf("TokenPocket") > -1) {
          this.isTP = true;
          tp.getCurrentWallet().then(res => {
            if (res.result) {
              if (process.env.VUE_APP_NETWORK_NAME === 'goerli' ||
                (res.data && res.data.blockchain_id == 1)
              ) {
                this.account = window.ethereum.selectedAddress;
                this.web3 = new Web3(window.ethereum);
              } else {
                this.switchTPWallet()
              }
            }
          })
          // this.judgeETH()
          //   .then((res) => {
          //     if (res) {
          //       this.account = window.ethereum.selectedAddress;
          //       // this.isETH = true;
          //       this.web3 = new Web3(window.ethereum);
          //     } else {
          //       throw new Error("wrong chain");
          //     }
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //     this.switchTPWallet();
          //   });
        } else {
          this.login()
          // if (window.ethereum) {
          //   this.login();
          //   // window.ethereum.on("accountsChanged", this.login);
          //   this.web3 = new Web3(window.ethereum);
          // } else {
          //   this.downloadVisible = true;
          // }
        }
      } catch (err) {
        console.log(err);
      }
    },
    /** walletconnect 钱包连接 */
    async onConnect() {
      const wallet = await onboard.connectWallet();
      // console.log('wallet', wallet);
      if (wallet.length) {
        this.web3 = new Web3(wallet[0].provider);
        this.evmProvider = wallet[0].provider
      }
      if (this.web3) {
        this.connected.account = wallet[0]?.accounts[0]?.address;
        this.connected.chainId = wallet[0]?.chains[0]?.id
      }
      // this.balance = wallet[0].accounts[0].balance;
    },
    /** 订阅钱包状态改变 */
    walletSubscribe() {
      const wallets = onboard.state.select();
      const { unsubscribe } = wallets.subscribe((update) => {
          // console.log('update', update)
          if (update.wallets.length) {
            this.web3 = new Web3(update.wallets[0].provider);
            this.evmProvider = update.wallets[0].provider
            if (this.web3) {
              this.connected.account = update.wallets[0]?.accounts[0]?.address
              this.connected.chainId = update.wallets[0]?.chains[0]?.id
            }
          } else {
            // 断开连接
            this.connected.account = ''
            this.connected.chainId = ''
            this.web3 = null
            this.evmProvider = null
            this.resetInfo()
          }
        }
      );
      this.unsubscribe = unsubscribe;
    },
    login() {
      this.onConnect()
      // window.ethereum
      //   .request({
      //     method: "eth_requestAccounts",
      //   })
      //   .then((res) => {
          // this.connected.account = "0x4cd4bc363458b52380d695b5c923b8994a245281";
          // this.connected.account = res[0];
          // this.connected.chainId = window.ethereum.chainId;
          // this.switchToETH();
          // ethereum.on("accountsChanged", (accounts) => {
          //   // this.connected.account = "0x4cd4bc363458b52380d695b5c923b8994a245281";
          //   this.resetInfo()
          //   this.connected.account = accounts[0];
          // });
          // ethereum.on("chainChanged", (chainId) => {
          //   this.connected.chainId = chainId;
          //   if (chainId === process.env.VUE_APP_CHAIN_ID) return;
          //   this.switchToETH();
          // });
        // });
    },
    switchToETH() {
      // console.log(process.env.VUE_APP_CHAIN_ID);
      return new Promise((resolve, reject) => {
        ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [
              {
                chainId: process.env.VUE_APP_CHAIN_ID,
              },
            ],
          })
          .then(resolve)
          .catch(reject);
      });
    },
    async judgeETH() {
      const chainId = parseInt(process.env.VUE_APP_CHAIN_ID, 16).toString();
      return new Promise((resolve, reject) => {
        let interval = setInterval(() => {
          if (window.injectTP) {
            clearInterval(interval);
            window.injectTP.getCurrentWallet().then((res) => {
              // const isETH = res.data.blockchain_id.toString() === chainId;
              // resolve(isETH);
              resolve(true);
            });
          }
        }, 300);
      });
    },
    setInfo() {
      this.getSubUid(this.account).then((res) => {
        this.getPledgeSubminerAsset(this.sub_uid).then(data => {
          this.initAssetsData(data)
        }).catch(err=> {
          this.getPledgeAsset().then((data) => {
            this.initAssetsData(data)
          });
        })
      })
      this.getEstimateGasFromKele()
      this.getEthBalance().then((data) => {
        this.balance = data;
      });
      Promise.all([this.getKLine(), this.getJointPending()]).then((res) => {
        console.log(this.joint.stakeDateStr);
        this.drawChart();
      });
      this.getHistory();
      this.getDayLimit().then((res) => {
        this.joint.dayLimit = res?.data?.data?.sum_limit_daily || 0;
        this.joint.everyoneDayLimit = res?.data?.data?.every_limit_daily || 0;
      });
      this.clearAndGetJointStakeInfo();
    },

    initAssetsData(data) {
      this.joint.staked = data.staked;
      this.joint.canWithdrawAmount = isNaN(data.balance)
        ? 0
        : BigNumber(data.balance).toString(10);
      const amount = isNaN(data.total_reward)
        ? 0
        : BigNumber(data.total_reward).toString(10);
      this.joint.withdrawIncomeAmount = amount
      this.joint.realWithdrawIncomeAmount = amount
      if (this.joint.withdrawIncomeAmount != 0) {
        this.joint.withdrawIncomeAmount = new BigNumber(this.joint.withdrawIncomeAmount).toFixed(6, 1)
      }
      let total_reward = isNaN(data.total_reward)
        ? 0
        : BigNumber(data.total_reward).toString(10);
      let withdraw_reward = isNaN(data.withdraw_reward)
        ? 0
        : BigNumber(data.withdraw_reward).toString(10);
      // 累计收益是 可提现收益 和 已提取收益 相加, 使用 bignumber 来相加
      let x = new BigNumber(total_reward)
      let y = x.plus(withdraw_reward).toString()
      if (y != 0) {
        y = new BigNumber(y).toFixed(6, 1)
      }
      // this.joint.total_reward = this.truncateDecimals(Number(total_reward) + Number(withdraw_reward), 6)
      this.joint.total_reward = y
      let computedNum = computeNumber(data.staked, '+', data.staking).next('+', data.unstaking).result
      this.joint.totalStaked = this.truncateDecimals(computedNum, 6)
    },
    /** 保留小数位不四舍五入 */
    truncateDecimals(num, digits) {
      try {
        let numS = num.toString()
        let decPos = numS.indexOf('.')
        let substrLength = decPos == -1 ? numS.length : 1 + decPos + digits
        let trimmedResult = numS.substr(0, substrLength)
        let finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;
        return parseFloat(finalResult);
      } catch (error) {
        console.log(error);
      }
    },

    clearAndGetJointStakeInfo() {
      this.getJointStakeInfo();
      if (this.joint.jointStakeInfoInterval) {
        clearInterval(this.joint.jointStakeInfoInterval);
      }
      this.joint.jointStakeInfoInterval = setInterval(() => {
        this.getJointStakeInfo();
      }, 20000);
    },
    getJointPending() {
      return new Promise((resolve, reject) => {
        axios
          .get("/v1/pledge/assetpending", {
            params: {
              from: this.account,
            },
          })
          .then((res) => {
            let unStakingCount, stakeDateStr;
            let hasUnStakingStatus = false;
            if (res.data && res.data.data && res.data.data.length) {
              res.data.data.map((item) => {
                if (item.action === "staking") {
                  let now = new Date();
                  let timestamp = Date.parse(now);
                  let stakeDate = new Date(
                    timestamp +
                      (item.total_days - item.cur_days) * 1000 * 60 * 60 * 24
                  );
                  stakeDateStr =
                    stakeDate.getFullYear() +
                    "-" +
                    (stakeDate.getMonth() + 1 < 10
                      ? "0" + (stakeDate.getMonth() + 1)
                      : stakeDate.getMonth() + 1) +
                    "-" +
                    (stakeDate.getDate() < 10
                      ? "0" + stakeDate.getDate()
                      : stakeDate.getDate());
                  this.joint.stakeDateStr = stakeDateStr;
                  // console.log(stakeDateStr);
                } else if (item.action === "unstaking") {
                  hasUnStakingStatus = true;
                  unStakingCount = item.pending_amt;
                  this.joint.unStakingCount = unStakingCount;
                }
              });
            }
            if (!hasUnStakingStatus) {
              this.joint.unStakingCount = 0;
            }
            resolve();
          });
      });
    },
    getJointStakeInfo() {
      axios
        .get("/v1/pledge/info", {
          params: {
            from: this.account,
          },
        })
        .then((data) => {
          if (data && data.data && data.data.data) {
            this.joint.confirmed_amount = data.data.data.confirmed_amount;
            this.joint.confirming_count = data.data.data.confirming_count;
          }
        });
    },
    getEthBalance() {
      return new Promise((resolve, reject) => {
        this.web3.eth.getBalance(this.account).then((balance) => {
          const etherString = ethers.utils.formatEther(balance);
          resolve(etherString);
        });
      });
    },
    getHistory() {
      axios
        .get("/v1/pledge/history", {
          params: {
            from: this.account,
          },
        })
        .then((res) => {
          this.joint.historyList = (res.data.data || []).map((item) => {
            return {
              amount: item.amount,
              status: item.status,
              op_id: item.op_id,
              unstake_type: item.unstake_type,
              op_time: dayjs(item.op_time).format("YYYY-MM-DD HH:mm:ss")
            };
          });
        });
    },
    getPledgeAsset() {
      // console.log(this.account);
      return new Promise((resolve, reject) => {
        axios
          .get("/v1/pledge/asset", {
            params: {
              from: this.account,
            },
          })
          .then((res) => {
            if (res?.data?.result === 1 || !res?.data?.data) {
              reject();
            }
            resolve(res.data.data);
          });
      });
    },
    addressParseOmit(text, leng1, len2) {
      if (!text || text.length <= 10) {
        return text;
      }
      return `${text.substring(0, leng1)}...${text.substring(
        text.length - len2
      )}`;
    },
    getKLine() {
      return new Promise((resolve, reject) => {
        if (!this.account) {
          return reject();
        }
        const now = new Date();
        let unit, unitCount;
        const timeZone = (now.getTimezoneOffset() / -60).toString();
        if (this.chart.interval === "day") {
          unit = "hour";
          unitCount = 24;
        } else if (this.chart.interval === "month") {
          unit = "day";
          unitCount = 30;
        }
        const params = {
          unit: unit,
          from: this.account,
          timezone: timeZone,
          unitcount: unitCount,
        };
        axios.get("/v1/pledge/getrewardkline", { params }).then((res) => {
          // console.log(res);
          const data = res.data.data || [];
          this.chart.yAxis = data.map((item) => {
            const reward = BigNumber(item.reward).toString(10);
            // console.log(reward);
            return reward;
          });
          let xAxis = data.map((item) => {
            return item.xstep;
          });
          if (xAxis.length === 0) {
            this.chart.xAxis = [];
            this.chart.yAxis = [];
            return resolve();
          }
          if (this.chart.interval === "day") {
            this.chart.xAxis = xAxis.map((item) => {
              const len = item.length;
              return item.substring(len - 5);
            });
          } else {
            if (
              xAxis[xAxis.length - 1].substring(0, 4) !==
              xAxis[0].substring(0, 4)
            ) {
              this.chart.xAxis = xAxis.map((item) => {
                return item.substring(2, 10).split("-").join("/");
              });
            } else {
              this.chart.xAxis = xAxis.map((item) => {
                return item.substring(5, 10).split("-").join("/");
              });
            }
          }
          // console.log(this.chart);
          resolve();
        });
      });
    },
    drawChart() {
      let xAxis = this.chart.xAxis || [];
      let yAxis = this.chart.yAxis || [];
      if (yAxis.length) {
        this.chart.hasData = true;
        // if (yAxis.length !== 1) {
        //   this.chart.xAxis0 = xAxis[0];
        //   xAxis[0] = "";
        // }
        // const len = yAxis.length;
        // let val = yAxis[len - 1].toString();
        // val = val.substring(0, val.indexOf(".") + 7);
        // let formatVal = val;
        // if (
        //   val.indexOf("e") !== -1 &&
        //   !isNaN(val.substring(val.indexOf("e") + 1)) &&
        //   Number(val.substring(val.indexOf("e") + 1) < 0)
        // ) {
        //   const count = Number(val.substring(val.indexOf("e") + 1));
        //   formatVal =
        //     "0." +
        //     "0".repeat(-count - 1) +
        //     val.substring(0, val.indexOf("e")).replace(".", "");
        // }
        // const xPosition = -9.5 * formatVal.length + 9;
        // yAxis[len - 1] = {
        //   value: formatVal,
        //   symbol: "circle",
        //   symbolSize: 7,
        //   label: {
        //     show: true,
        //     fontSize: 12,
        //     fontFamily: "PingFangSC-Regular, PingFang SC",
        //     fontWeight: 400,
        //     position: [xPosition, -35],
        //     // backgroundColor: {
        //     //   image: require("../../assets/img/label_bg.png"),
        //     //   // height: 30
        //     // },
        //     padding: 10,
        //     formatter() {
        //       return formatVal;
        //     },
        //   },
        //   itemStyle: {
        //     borderWidth: 1.5,
        //     borderColor: "#2890FD",
        //     color: "white",
        //   },
        // };
      } else {
        this.chart.hasData = false;
        // xAxis = [""];
        // yAxis = [0];
      }
      const option = {
        title: {
          show: !this.chart.hasData,
          text: !Number(this.joint.confirmed_amount)
            ? this.$t("noData")
            : this.$t("predictIncome") + this.joint.stakeDateStr,
          top: "center",
          left: "center",
          textStyle: {
            color: this.chart.noDataColor,
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "font-family: PingFangSC-Regular, PingFang SC;",
            rich: {
              a: {
                backgroundColor: {
                  image: this.isDarkMode
                    ? require("../assets/no-history-dark.png")
                    : require("../assets/no-history-day.png"),
                },
                fontSize: 20,
              },
            },
          },
        },
        grid: {
          left: 0,
          right: 25,
          top: 30,
          bottom: this.isMobileSize ? 0 : 60,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxis,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontFamily: "PingFangSC-Regular, PingFang SC",
            fontWeight: 400,
            color: this.chart.labelColor,
            fontSize: 10,
          },
          splitLine: {
            lineStyle: {
              color: this.chart.lineColor,
              width: 0.5,
            },
            show: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontFamily: "PingFangSC-Regular, PingFang SC",
            fontWeight: 400,
            color: this.chart.labelColor,
            fontSize: 10,
          },
          splitLine: {
            lineStyle: {
              color: this.chart.lineColor,
              width: 0.5,
            },
          },
        },
        series: [
          {
            type: "line",
            symbol: "none",
            data: yAxis,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#2980fe",
                },
                {
                  offset: 1,
                  color: "rgba(41,128,254,0)",
                },
              ]),
            },
            markLine: {},
            lineStyle: {
              color: this.chart.lineColor,
              width: 1,
            },
          },
        ],
      };

      this.chart.option = option;
      this.chart.lineChart.setOption(this.chart.option, {
        notMerge: true,
      });
    },
    drawBar() {
      let xAxis = [],
        incomeSeries = [],
        mevIncomeSeries = [];
      this.selfHost.incomeList.forEach((item) => {
        xAxis.push(item.date.substring(0, 10));
        incomeSeries.push(item.reward);
        const mevIncomeItem = this.selfHost.mevIncomeList.find(
          (item1) => item1.time.substring(0, 10) === item.date.substring(0, 10)
        );
        mevIncomeSeries.push(mevIncomeItem ? Number(mevIncomeItem.amount) : 0);
      });
      if (xAxis.length) {
        this.selfHostChart.hasData = true;
      } else {
        this.selfHostChart.hasData = false;
      }
      const option = {
        title: {
          show: !this.selfHostChart.hasData,
          text: this.$t("noData"),
          top: "center",
          left: "center",
          textStyle: {
            color: this.chart.noDataColor,
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "font-family: PingFangSC-Regular, PingFang SC;",
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: this.selfHostChart.shadowBg,
              // color: 'rgba(0, 0, 0, 0.3)',
            },
          },
          backgroundColor: this.selfHostChart.tooltipBg,
          borderColor: "#e6e8ea",
          borderWith: 1,
          borderRadius: 8,
          padding: [8, 16],
          formatter: (params) => {
            const date = params && params[0] && params[0].name;
            let total = 0;
            let str = "";
            for (let item of params) {
              total += item.value;
              str += `<div style='display: flex; align-items: center;'>
                  <div style='background-color: ${item.color}; width: 6px; height: 6px; border-radius: 5px; margin-right: 8px'></div>
                  <span style='color: ${item.color};'>${item.seriesName}: ${item.value}</span>
                </div>`;
            }
            const html = `<div style='font-size: 12px'>
                <p style='color: #71747a'>${date}</p>
                ${str}
                <p style='color: ${this.selfHostChart.totalColor}'>${this.$t(
              "total"
            )}: ${total}</p>
              </div>`;
            return html;
          },
        },
        legend: {
          left: -3,
          top: 4,
          itemWidth: 6,
          itemHeight: 6,
          borderRadius: 3,
          icon: "circle",
          itemGap: 24,
          textStyle: {
            color: "#fft",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: this.isMobileSize ? 35 : 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontFamily: "PingFangSC-Regular, PingFang SC",
              fontWeight: 400,
              color: "#72777b",
              fontSize: 10,
            },
            splitLine: {
              lineStyle: {
                color: this.selfHostChart.splitLineColor,
                width: 0.5,
              },
              show: true,
            },
            axisLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontFamily: "PingFangSC-Regular, PingFang SC",
              fontWeight: 400,
              color: "#72777b",
              fontSize: 10,
            },
            splitLine: {
              lineStyle: {
                color: this.selfHostChart.splitLineColor,
                width: 0.5,
              },
            },
            axisLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: this.$t("consensusIncome"),
            type: "bar",
            stack: "income",
            emphasis: {
              focus: "none",
            },
            data: incomeSeries,
            itemStyle: {
              color: "#2980fe",
            },
          },
          {
            name: this.$t("executionIncome"),
            type: "bar",
            stack: "income",
            emphasis: {
              focus: "none",
            },
            data: mevIncomeSeries,
            itemStyle: {
              color: "#80e8c5",
            },
          },
        ],
      };
      this.selfHostChart.option = option;
      this.selfHostChart.barChart.setOption(this.selfHostChart.option, {
        notMerge: true,
      });
    },
    alterStakeInputAmount() {
      this.joint.stakeInputAmount = this.alterInputAmount(
        this.joint.stakeInputAmount
      );
    },
    alterUnstakeInputAmount() {
      this.joint.unstakeInputAmount = this.alterInputAmount(
        this.joint.unstakeInputAmount
      );
    },
    alterInputAmount(inputAmount) {
      let res = "";
      if (inputAmount) {
        res = inputAmount.replace(/[^\d.]/g, "");
        if (
          (inputAmount.charAt(inputAmount.length - 1) === "." &&
            inputAmount.indexOf(".") !== inputAmount.length - 1) ||
          inputAmount.indexOf(".") === 0
        ) {
          res = inputAmount.substring(0, inputAmount.length - 1);
        }
      }
      if (
        inputAmount.indexOf(".") !== -1 &&
        inputAmount.length > inputAmount.indexOf(".") + 8
      ) {
        res = inputAmount.substring(0, inputAmount.indexOf(".") + 9);
      }
      return res;
    },
    submit() {
      // this.showUpgradeModal()
      const isUpgrade = this.showUpgradeModal()
      if (isUpgrade) {
        return
      }
      // console.log(this.joint.stakeInputAmount);
      if (parseFloat(this.joint.stakeInputAmount) < this.allowAmount) {
        // if (parseFloat(this.joint.stakeInputAmount) < 0.001) {
        this.showToast(0);
        return;
      } else if (parseFloat(this.joint.stakeInputAmount) > 32000) {
        this.showToast(1);
        return;
      } else if (
        this.joint.activity.activity_available === 1 &&
        parseFloat(this.joint.stakeInputAmount) >
          this.joint.activity.activity_remain_mount
      ) {
        this.showToast(2);
        return;
      }
      this.participate();
    },
    async participate() {
      this.joint.transfering = true;
      if (this.joint.activity.activity_available === 1) {
        // activity
        try {
          await this.getActivityInfo();
          if (this.joint.activity.activity_available !== 1) {
            this.showToast(4);
            this.joint.transfering = false;
            this.joint.stakeInputAmount = "";
            return false;
          }
        } catch (err) {
          this.showToast(5);
          return false;
        }
      }
      if (window.ethereum.chainId !== process.env.VUE_APP_CHAIN_ID) {
        this.account = "";
        this.showToast(12);
        return;
      }
      this.anonymouslogin().then(() => {
        this.stakeByContract()
      }).catch(err => {
        console.log(err);
        this.joint.transfering = false;
        this.showToast(15)
      })
      // this.web3.eth.sendTransaction(
      //   {
      //     from: this.account,
      //     to: "0x65B11d8e1E63E09edcfBDC72e05ecA001B42C307",
      //     value: value.toString(),
      //     // value: '0x'+value,
      //   },
      //   (error, hash) => {
      //     if (error) {
      //       this.showToast(6);
      //       this.joint.transfering = false;
      //     } else if (hash) {
      //       this.joint.hash = hash;
      //       this.hashSend(stakeAmount);
      //     }
      //   }
      // );
    },
    showToast(type) {
      let txt;
      if (type === 0) txt = this.$t("belowCount");
      else if (type === 1) txt = this.$t("overCount");
      else if (type === 2)
        txt = this.$t("overActivityCount", {
          msg: this.joint.activity.activity_remain_mount,
        });
      else if (type === 4) txt = this.$t("activityEnd");
      else if (type === 5) txt = this.$t("unknownError");
      else if (type === 6) txt = this.$t("fail");
      else if (type === 7) txt = this.$t("success");
      else if (type === 8) txt = this.$t("usedOut");
      else if (type === 9) txt = this.$t("exitSuccess");
      else if (type === 10) txt = this.$t("exitFailed");
      else if (type === 11) txt = this.$t("copied");
      else if (type === 12) txt = this.$t("networkError");
      else if (type === 13) txt = this.$t("unknownError");
      else if (type === 14) txt = this.$t("unStakeSuccess");
      else if (type === 15) txt = this.$t("anonymousloginError");
      this.toastMsg = txt;
      setTimeout(() => {
        this.toastMsg = "";
      }, 3000);
    },
    async hashSend(stakeAmount) {
      const mode = this.joint.activity.activity_available === 1 ? 1 : 0;
      await axios.post("/v1/pledge", {
        from: this.account,
        tx_id: this.joint.hash,
        amount: stakeAmount,
        mode: mode,
      });
      this.joint.transfering = false;
      this.joint.stakeInputAmount = "";
      this.showToast(7);
      // this.getActivityInfo();
      // this.getEthBalance().then((data) => {
      //   this.balance = data;
      // });
      // this.clearAndGetJointStakeInfo()
      // clearInterval(this.joint.InfoInterval);
      // this.joint.InfoInterval = null;
      // await this.getInfo();
      // this.joint.InfoInterval = setInterval(() => {
      //   this.getInfo();
      // }, 20000);
      this.setInfo();
    },
    getActivityInfo() {
      return new Promise((resolve, reject) => {
        axios
          .get("v1/pledge/available_pledge_balance")
          .then((res) => {
            if (res && res.data && res.data.data) {
              this.joint.activity.balance = Number(res.data.data.balance);
              this.joint.activity.activity_remain_mount = Number(
                res.data.data.activity_remain_mount
              );
              this.joint.activity.activity_available =
                res.data.data.activity_available;
              resolve();
            } else {
              reject("No data");
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getDayLimit() {
      return new Promise((resolve, reject) => {
        axios
          .get("/v1/pledge/withdrawal_limit_daily", {
            params: {
              from: this.account,
            },
          })
          .then(resolve)
          .catch(reject);
      });
    },
    unstakeSubmit() {
      this.joint.unstakeTransfering = true;
      this.walletSign(String(this.joint.unstakeInputAmount), 0, '/eth2/v1/subminer/unstake_v2')
      // this.ethSign()
      //   .then((res) => {
      //     console.log('res', res);
      //     const { ethResult, msg, timestamp, value } = res;
      //     this.unStake(ethResult, msg, timestamp, value, this.unstake_type);
      //   })
      //   .catch((err) => {
      //     console.log('err', err);
      //     this.joint.unstakeTransfering = false;
      //   });
    },
    ethSign() {
      return new Promise((resolve, reject) => {
        try {
          let value;
          if (this.joint.unstakeInputAmount.indexOf(".") !== -1) {
            const n =
              this.joint.unstakeInputAmount.length -
              this.joint.unstakeInputAmount.indexOf(".") -
              1;
            value =
              Math.round(
                Number(this.joint.unstakeInputAmount) * Math.pow(10, n)
              ) * Math.pow(10, 9 - n);
          } else {
            value = Number(this.joint.unstakeInputAmount) * Math.pow(10, 9);
          }
          const timestamp = Date.parse(new Date());
          let msg = timestamp.toString() + value.toString();
          msg = `0x${Buffer.from(msg, "utf8").toString("hex")}`;
          ethereum
            .request({
              method: "personal_sign",
              params: [msg, this.account],
            })
            .then((ethResult) => {
              resolve({
                ethResult,
                msg,
                timestamp,
                value,
              });
            })
            .catch((err) => {
              console.log(err);
              throw new Error(err);
            });
        } catch (err) {
          console.log(err);
          reject();
        }
      });
    },
    /** 发送赎回请求 */
    unStake(sign, signMessage, value, timestamp, unstake_type, order_id) {
      this.toastType = 0
      axios
        .post("/v1/pledge/unstake", 
          {
            from: this.account,
            amount: value,
            timestamp: timestamp.toString(),
            unstake_type: unstake_type,
            order_id: order_id.toString(),
          },
          {
            headers: {
              'Kele-Private-Sign': sign,
              '_pirv_sign_raw': signMessage,
            },
          }
        )
        .then((res) => {
          this.joint.unstakeTransfering = false;
          this.joint.unstakeInputAmount = "";
          if (res.data.result === 0) {
            this.toastTitle = this.$t('unStakeSuccess')
            this.showWithdrawToast()
          } else {
            this.showToast(10);
          }
          this.setInfo();
        }).catch(err => {
          this.joint.unstakeTransfering = false;
        });
    },
  
    selfHostSubmit() {
      const isUpgrade = this.showUpgradeModal()
      if (isUpgrade) {
        return
      }
      this.selfHost.transfering = true;
      const promiseList = [this.getKeypair(), this.anonymouslogin()];
      Promise.all(promiseList)
        .then((res) => {
          const data = res[0];
          this.selfHostStake(data);
        })
        .catch((err) => {
          console.log(err);
          this.selfHost.transfering = false;
        });
    },
    selfHostStake(data) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const kelepool = {
        address: process.env.VUE_APP_KELE_CONTRACT,
        abi: ABI,
      };
      const contract = new ethers.Contract(
        kelepool.address,
        kelepool.abi,
        signer
      );
      let stakingPublicKey = "";
      let stakingSignature = "";
      const stakingCredentials = this.deposit_credentials; // 用户提款凭证
      let stakingRoot = [];
      for (let i = 0; i < data.length; i++) {
        let validator = data[i];
        if (validator.network_name !== process.env.VUE_APP_NETWORK_NAME) {
          this.selfHost.transfering = false;
          return this.showToast(13);
        }
        stakingPublicKey += validator.pubkey; // 拼接公钥字符串
        stakingSignature += validator.signature; // 拼接签名字符串
        stakingRoot.push("0x" + validator.deposit_data_root); // 拼接默克尔树字符串
      }

      // 生成大额质押合约参数
      const prefix = "0x";
      const pubkey = ethers.utils.arrayify(prefix + stakingPublicKey);
      const withdrawal_credentials = ethers.utils.arrayify(
        prefix + stakingCredentials
      );
      const signature = ethers.utils.arrayify(prefix + stakingSignature);
      const deposit_data_root = stakingRoot;
      const amountStr = this.selfHostStakeAmount;
      const amount = ethers.utils.parseUnits(amountStr, "ether");
      const source = ethers.utils.arrayify(
        ethers.utils.formatBytes32String("tokenpocket")
      );
      if (window.ethereum.chainId !== process.env.VUE_APP_CHAIN_ID) {
        this.account = "";
        this.showToast(12);
        this.selfHost.transfering = false;
        return;
      }
      if (
        this.prevKeypalInfo.phone &&
        this.prevKeypalInfo.selectedCountryCode
      ) {
        const params = {
          wallet_address: this.account,
          user: this.prevKeypalInfo.address,
          phone: this.prevKeypalInfo.phone,
          post_code: this.prevKeypalInfo.emailCode,
          ship_address: this.prevKeypalInfo.addressDetails,
          area_code: this.prevKeypalInfo.selectedCountryCode.phone_code,
          email: this.prevKeypalInfo.email,
        };
        this.addPledgeUserOrder(params).then((orderId) => {
          this.selfHost.orderId = orderId;
        });
      }
      contract
        .createValidatorV2(
          1,
          source,
          pubkey,
          withdrawal_credentials,
          signature,
          deposit_data_root,
          {
            from: this.account, // 调用者账号
            value: amount, // 质押金额
          }
        )
        .then((res) => {
          console.log(res);
          if (this.selfHost.orderId) {
            const params = {
              order_id: this.selfHost.orderId,
              hash: res.hash,
            };
            this.updatePledgeUserOrderHash(params);
          }
          this.showToast(7);
          this.setSelfHostInfo();
          this.getEthBalance().then((data) => {
            this.balance = data;
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.selfHost.transfering = false;
        });
    },
    /** 大额赎回 */
    selfHostUnStake(node_ids) {
      const api_params = {
        type: 'whale',
        address: this.account,
        node_ids: String(node_ids),
      }
      // console.log('大额质押发起赎回参数', api_params);
      this.walletSign('32', 3, '/eth2/v2/miner/unstake', api_params)
    },
    /** 发起大额赎回请求 */
    sendSelfHostUnStake(sign, signMessage) {
      this.toastType = 0
      console.log('sendSelfHostUnStake');
      axios.post(COMMON_API, 
        {
          _pirv_sign_raw: signMessage
        },
        {
          headers: {
            'Kele-Private-Sign': sign,
            api: '/eth2/v2/miner/unstake'
          },
        }
      ).then(res => {
        if (res.data && 
          res.data.result === 0 &&
          res.data.data 
        ) {
          this.toastTitle = this.$t('unStakeSuccess')
          this.showWithdrawToast()
          this.setSelfHostInfo();
          this.getEthBalance().then((data) => {
            this.balance = data;
          });
        } else {
          this.showToast(10);
        }
      }).catch(err=>{
        this.showToast(10);
        console.log(err);
      })
    },
    /** 批量查询节点状态 */
    getSelfHostValidators(validators) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            COMMON_API,
            {
              address: this.account,
              op_type: 2,
            },
            {
              headers: {
                api: "/eth2/v2/validators",
              },
            }
          )
          .then((res) => {
            if (res && res.data && res.data.result === 0) {
              resolve();
            } else {
              reject();
            }
          })
          .catch(reject);
      });
    },
    addPledgeUserOrder(params) {
      return new Promise((resolve) => {
        axios.post("v1/pledge/pledge_user_order", params).then((res) => {
          console.log(res);
          if (res && res.data && res.data.data) {
            resolve(res.data.data);
          }
        });
      });
    },
    updatePledgeUserOrderHash(params) {
      axios
        .post("v1/pledge/update_pledge_user_order_hash", params)
        .then((res) => {
          console.log(res);
        });
    },
    getKeypair() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            COMMON_API,
            {
              deposit_credentials: this.deposit_credentials,
              count: this.selfHost.endpointAmount,
              recreate: 0,
            },
            {
              headers: {
                api: "/eth2/v2/validator/keypair",
              },
            }
          )
          .then((res) => {
            if (res && res.data && res.data.data) {
              resolve(res.data.data);
            } else {
              return new Error("No data");
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    anonymouslogin() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            COMMON_API,
            {
              payee_addr: this.account,
              token: "eth",
              source: "tokenpocket",
            },
            {
              headers: {
                api: "/user/v2/anonymouslogin",
              },
            }
          )
          .then((res) => {
            if (res && res.data && res.data.result === 0) {
              resolve();
            } else {
              reject();
            }
          })
          .catch(reject);
      });
    },
    setSelfHostInfo() {
      this.getSelfHostDashboard();
      this.getSelfHostEndpoint();
      this.getSelfHostHistory();
      Promise.all([this.getSelfHostIncome(), this.getSelfHostMevIncome()]).then(
        (res) => {
          const [incomeRes, mevIncomeRes] = res;
          let incomeList =
            incomeRes.length > 20 ? incomeRes.slice(0, 20) : incomeRes;
          const mevIncomeList = (mevIncomeRes.data || []).filter((item) => {
            const incomeItem = incomeList.find(
              (item1) =>
                item1.date.substring(0, 10) === item.time.substring(0, 10)
            );
            return incomeItem;
          });
          this.selfHost.incomeList = incomeList.reverse();
          this.selfHost.mevIncomeList = mevIncomeList.reverse();
          if (this.selfHostChart.barChart) {
            this.drawBar();
          }
        }
      );
    },
    getSelfHostDashboard(type) {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            params: {
              address:
                this.account || "0xfd80c819c71fbd4916e51ceae55bd55c3f5133eb",
              interval: "day",
              source: 'tokenpocket'
            },
            headers: {
              api: "/eth2/v2/miner/dashboard",
            },
          })
          .then((res) => {
            if (res && res.data && res.data.data) {
              const data = res.data.data;
              const estimate_annualized = BigNumber(data.income.apr)
                .times(100)
                .toString();
              this.joint.estimate_annualized = `${estimate_annualized}%`;
              this.selfHost.estimate_annualized = `${estimate_annualized}%`;
              // const estimate_annualized = data.income.apr;
              if (type !== "apr") {
                // this.selfHost.staked = data.amount.total_amount;
                this.selfHost.staked = data.amount.whale_staked;
                // this.selfHost.total_reward = data.income.total_reward;
                this.selfHost.total_reward = data.income.whale_total_reward;
              }
            }
          });
      });
    },
    getSelfHostGlobal() {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            headers: {
              api: "/eth2/v2/global",
            },
          })
          .then((res) => {
            // console.log(res);
            this.validator_alive_predicted_hour = res.data?.data?.validator_alive_predicted_hour || undefined
          });
      });
    },
    getSelfHostIncome() {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            params: {
              address: this.account,
            },
            headers: {
              api: "/eth2/v2/miner/income/query",
            },
          })
          .then((res) => {
            if (res && res.data && res.data.data) {
              resolve(res.data.data);
            } else {
              throw new Error("No data");
            }
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      });
    },
    getSelfHostMevIncome() {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            params: {
              address: this.account,
              page_number: 1,
              page_size: 20,
            },
            headers: {
              api: "/eth2/v2/mev_reward",
            },
          })
          .then((res) => {
            if (res && res.data && res.data.data) {
              resolve(res.data.data);
            } else {
              throw new Error("No data");
            }
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      });
    },
    getSelfHostEndpoint() {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            params: {
              address: this.account,
            },
            headers: {
              api: "/eth2/v2/miner/validator/query",
            },
          })
          .then((res) => {
            if (res && res.data && res.data.data) {
              const endpointList = res.data.data;
              endpointList.forEach((item) => {
                if (item.apr) {
                  item.apr_visible = BigNumber(item.apr).times(100).toString();
                }
                if (item.reward) {
                  item.reward_visible = this.fixDecimals(item.reward, 6);
                }
                if (item.node_exit_est_date) {
                  const timestamp = Date.parse(new Date()) / 1000;
                  item.node_exit_est_date = item.node_exit_est_date - timestamp
                  item.node_exit_est_date = secondsToDays(item.node_exit_est_date);
                }
              });
              this.selfHost.endpointList = res.data.data;
            }
          });
      });
    },
    getSelfHostHistory(page_number = 1, page_size = 20) {
      return new Promise((resolve, reject) => {
        axios
          .get(COMMON_API, {
            params: {
              address: this.account,
              op_type: '1,2,3,5,6,7',
              type: 1,
              page_number,
              page_size
            },
            headers: {
              api: "/eth2/v4/op_history",
            },
          })
          .then((res) => {
            // console.log(res.data.data);
            if (res && res.data && res.data.data && res.data.data.data) {
              res.data.data.data.forEach(item => {
                // op_type 1: 质押 2: 赎回 3: 平台提现 4: 链上提现 5: 快速质押 6:快速赎回 7:快速质押不足（部分退款）
                item.type_text = this.$t( 'self_host_op_type.' + item.op_type)
                if (item.op_type === 1 || item.op_type === 5 || item.op_type === 7) {
                  item.amount = '-' + item.amount
                } else {
                  item.amount = '+' + item.amount
                }
              })
              this.page_number++
              this.selfHost.stakeHistoryList = _.uniqBy([...this.selfHost.stakeHistoryList, ...res.data.data.data]);
            }
          });
      });
    },
    switchTPWallet() {
      const chainId = parseInt(process.env.VUE_APP_CHAIN_ID, 16).toString();
      tp.getWallet({
        walletTypes: [chainId],
        switch: true,
      })
        .then((res) => {
          if (res.result) {
          }
        })
        .catch(console.log);
    },
    getLocaleTime(utcTime) {
      if (!utcTime) return null;
      const timeStr = utcTime.replace(" ", "T") + "Z";
      let time = dayjs(timeStr).format("YYYY-MM-DD HH:mm:ss");
      return time;
    },
    getLocaleTimeV1(utcTime) {
      if (!utcTime) return null;
      const date = new Date(utcTime);
      const localDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
      return localDate.toLocaleString();
    },
    openExplorer(item) {
      // console.log(item);
      let txHash = ''
      if (item && this.statusType === 'selfHost') {
        // 自托管质押
        txHash = item.transaction_id
      } else if (item && item.unstake_type === -1) {
        // 联合质押
        txHash = item.op_id
      }
      if (txHash) {
        const url = process.env.VUE_APP_HASH_EXPLORER.replace("{hash}", txHash);
        window.open(url);
      }
    },
    openAddressExplorer() {
      window.open(
        process.env.VUE_APP_ADDRESS_EXPLORER.replace("{address}", this.account)
      );
    },
    openUrl(url) {
      window.open(url);
    },
    resetInfo() {
      this.joint = {
        ...this.joint,
        withdrawIncomeAmount: 0, // 可提现的收益
        canWithdrawAmount: 0, // 总可提现余额（本金+收益）
        staked: null,
        totalStaked: 0,
        total_reward: null,
        estimate_annualized: null,
        transfering: false,
        historyVisible: false,
        historyList: [],
        dayLimit: 0,
        everyoneDayLimit: 0,
        unstakeTransfering: false,
        confirming_count: 0,
        confirmed_amount: 0,
        stakeDateStr: "",
        unStakingCount: 0,
      };
      this.selfHost = {
        ...this.selfHost,
        staked: null,
        total_reward: null,
        estimate_annualized: null,
        endpointList: [],
        stakeHistoryList: [],
        endpointAmount: 1,
        incomeList: [],
        mevIncomeList: [],
        transfering: false,
        orderId: null,
      };
      this.balance = 0;
      this.chart = {
        ...this.chart,
        xAxis: [],
        yAxis: [],
        xAxis0: null,
        hasData: false,
        noAsset: false,
        option: {},
      };
      this.selfHostChart = {
        ...this.selfHostChart,
        hasData: false,
        noAsset: false,
        option: {},
      };
      this.drawChart();
      if (this.selfHostChart.barChart) {
        this.drawBar();
      }
      if (this.joint.jointStakeInfoInterval) {
        clearInterval(this.joint.jointStakeInfoInterval);
        this.joint.jointStakeInfoInterval = null;
      }
    },
    fixDecimals(value, decimals) {
      let valueStr = BigNumber(value).toString(10);
      const index = valueStr.indexOf(".");
      if (index !== -1) {
        valueStr = valueStr.substring(0, index + decimals + 1);
      }
      return valueStr;
    },
    resetKeypalInfo() {
      this.keypalInfo = cloneDeep(this.prevKeypalInfo);
      this.keypalVisible = false;
    },
    setPrevKeypalInfo() {
      this.prevKeypalInfo = cloneDeep(this.keypalInfo);
      console.log(this.prevKeypalInfo);
      this.keypalVisible = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../_variables.less";
.whole {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.necessary {
  color: var(--total-income-bg);
  margin-right: 5px;
}

.stake-vault {
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: fit-content;
  min-width: 100%;
  min-height: 100vh;

  &.dark {
    background-image: url("../assets/bg-pc-dark.png");
  }
  &.day {
    background-image: url("../assets/bg-pc-day.png");
  }

  .toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 5px 20px;
    color: white;
    background: rgba(0, 0, 0, 0.7);
    width: fit-content;
    height: fit-content;
    border-radius: 8px;
    z-index: 999;
  }
  .header {
    color: white;
    // font-family: Inter, Inter-Medium;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 55px;

    .logo {
      height: 32px;
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .locale-outer {
        position: relative;
      }

      .locale-wrap {
        display: flex;
        align-items: center;
        margin-left: 40px;
        z-index: 99;

        img {
          margin-right: 8px;
          height: 24px;
        }

        .locale-slide {
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .locale {
          font-size: 16px;
          font-weight: 500;
          margin-right: 8px;
        }

        .locale-arrow {
          transform: scale(0.5, 1.2);
          rotate: 90deg;
        }
      }
      .locale-menu {
        position: absolute;
        font-size: 16px;
        font-weight: 500;
        width: 128px;
        padding: 12px;
        text-align: center;
        top: 40px;
        left: 50%;
        margin-left: -42px;
        border-radius: 12px;
        color: #3a3b3d;
        background: white;
        box-shadow: 0px 6px 16px 0px rgba(45, 54, 86, 0.05);
        border: 1px solid #f1f3f5;
        z-index: 299;

        &-item {
          padding: 12px 0;
          cursor: pointer;

          &:hover {
            color: #2980fe;
          }
        }
      }
    }

    .mode-wrap {
      display: flex;
      align-items: center;

      .moon {
        width: 20px;
        margin-right: 10px;
      }

      .mode {
        margin-right: 8px;
      }
    }
  }

  .title {
    width: 1200px;
    padding: 8px 16px;
    background: var(--title-bg);
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: white;
    margin: 12px auto 10px;

    img {
      height: 24px;
      margin-right: 16px;
    }
  }

  .content {
    height: 638px;
    width: 1200px;
    margin: 0 auto;
    display: flex;

    .left {
      width: 349px;
      flex-shrink: 0;
      margin-right: 16px;

      .overview {
        height: 393px;
        border-radius: 8px;
        background-color: var(--overview-panel-bg);
        padding: 16px;

        .connect {
          height: 46px;
          line-height: 46px;
          background: var(--overview-content-bg);
          color: var(--connect-color);
          border-radius: 4px;
          text-align: center;
          cursor: pointer;
        }

        .switch {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 46px;
          border-radius: 4px;
          background-color: #f8dada;
          color: #f56459;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;

          .enter {
            margin-left: 4px;
            transform: scale(0.5, 1.2) translateY(-1.4px);
          }
        }

        .account-info {
          display: flex;
          align-items: center;

          .account-wrap {
            display: flex;
            align-items: center;
          }

          .chain-logo {
            width: 42px;
            margin-right: 1.5px;
          }
          .account {
            font-size: 16px;
            color: white;
            margin-left: 8px;

            &-switch {
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 12px;
              background-color: rgba(255, 255, 255, 0.5);
              margin-left: 4px;
              padding: 4px 12px;
              color: #ffffff;
              cursor: pointer;

              &-title {
                font-size: 12px;
                font-weight: 500;
              }

              &-arrow {
                transform: scale(1.2, 0.5) rotate(90deg);
                margin-left: 4px;
              }
            }
          }
          .balance-wrap {
            margin-left: auto;
            text-align: right;
            color: white;

            .balance-label {
              font-size: 18px;
              font-weight: 600;
            }

            .balance-value {
              opacity: 0.7;
              font-size: 13px;
              font-weight: 400;
            }
          }
        }

        .overview-staked {
          margin-top: 16px;
          height: 220px;
          border-radius: 8px;
          background-color: var(--overview-content-bg);
          background-size: 162px 104px;
          background-image: url("../assets/tp.png");
          background-position: top right;
          background-repeat: no-repeat;

          &.dark {
            background-image: url("../assets/tp-dark.png");
          }

          .total-staked {
            height: 109px;
            padding-top: 1px;
          }

          .staked-details {
            display: flex;

            .self-host-staked,
            .joint-staked {
              width: 50%;
            }
          }

          .split-line {
            width: 253px;
            height: 1px;
            margin-left: 24px;
            background-color: #e6e8ea;
            opacity: 0.3;
          }

          .staked-label {
            margin-top: 16px;
            margin-left: 24px;
            margin-right: 10px;
            color: white;
            font-size: 14px;
            font-weight: 400;
            word-break: break-all;
          }

          .staked-value {
            margin-top: 8px;
            margin-left: 24px;
            font-size: 22px;
            font-weight: 600;
            color: #f2f2f2;
            word-break: break-all;
          }
        }

        .total-income {
          background-color: var(--total-income-bg);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
          color: white;
          height: 52px;
          margin-top: 16px;

          &-label {
            font-size: 14px;
            font-weight: 500;
          }

          &-value {
            font-size: 16px;
            font-weight: 600;
          }
        }
      }

      .knowledge {
        margin-top: 16px;
        height: 229px;
        background-color: var(--overview-panel-bg);
        border-radius: 8px;
        padding: 16px;

        &-title {
          color: #ffffff;
          font-weight: 600;
          font-size: 20px;
        }

        &-item {
          height: 40px;
          line-height: 40px;
          padding: 0 16px;
          background-color: var(--overview-content-bg);
          margin-top: 12px;
          color: #ffffff;
          font-size: 14px;
          font-weight: 500;
          position: relative;
          border-radius: 8px;
          cursor: pointer;

          &::after {
            content: ">";
            transform: scale(0.5, 1.2);
            position: absolute;
            right: 16px;
          }
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      background-color: var(--details-panel-bg);
      border-radius: 8px;
      padding: 9px 16px;
      position: relative;
      overflow: hidden;

      &.with-cover {
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.32);
          left: 0;
          top: 0;
        }
      }

      .stake-type-tabs {
        position: relative;
        .tab {
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          text-align: center;
        }
        .self-host-tab {
          position: relative;
        }
        &::after {
          content: "NEW";
          position: absolute;
          right: -26px;
          top: -4px;
          font-size: 12px;
          color: white;
          font-weight: 500;
          padding: 2px 8px;
          background: linear-gradient(180deg, #ff5757, #ff9e57 100%);
          border-radius: 8px 0px 8px 0px;
          line-height: initial;
        }
      }

      .details-overview {
        display: flex;
        justify-content: space-between;
        height: 100px;
        margin-top: 16px;
        color: white;
        border: 1px solid var(--tabs-border);
        border-radius: 8px;

        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          // justify-content: center;
          margin-top: 12px;
          flex: 1;

          .label {
            // color: var(--details-overview-label-color);
            color: var(--color);
            font-size: 14px;
            margin-bottom: 8px;
            font-weight: 500;
            text-align: center;
          }

          .value {
            color: var(--details-overview-value-color);
            font-size: 20px;
            font-weight: 600;
            height: 30px;
            line-height: 30px;
          }

          &.total-income {
            .value {
              color: var(--details-total-income-color);
              background: var(--details-total-income-bg);
              padding: 0 20px;
              border-radius: 12px;
              height: 30px;
              line-height: 30px;
            }
          }

          &.estimate-annualized {
            // flex: 1.5;
            .value {
              color: var(--estimate-annual-color);
              height: 30px;
              line-height: 30px;
            }

            .value-wrap {
              display: flex;
              align-items: center;

              .self-host-btn {
                margin-left: 8px;
                padding: 6px 32px;
                color: white;
                background: var(--withdraw-mobile-bg);
                color: #fff;
                font-weight: 500;
                font-size: 12px;
                border-radius: 25px;
                cursor: pointer;
              }
            }
          }

          &.withdraw-income {
            flex: 2;
            .label {
              display: flex;
              align-items: center;
              margin-bottom: 2px;
              img {
                margin-left: 4px;
                width: 16px;
              }
            }
            .estimate-gas {
              font-size: 12px;
              color: var(--details-overview-label-color);
              margin-bottom: 8px;
              font-weight: 400;
            }
            .amount-wrap {
              display: flex;
              align-items: center;
              .amount {
                background: var(--details-total-income-bg);
                border-radius: 32px;
                font-size: 20px;
                font-weight: 600;
                text-align: center;
                color: var(--details-total-income-color);
                padding: 0 24px;
                height: 32px;
                line-height: 32px;
              }
              .btn {
                margin-left: 8px;
                background: var(--withdraw-mobile-bg);
                font-size: 12px;
                // color: var(--self-stake-btn-color);
                color: #fff;
                &.disabled {
                  background: var(--withdraw-mobile-disabled-bg);
                }
              }
            }
          }
        }
      }

      .tips-content {
        margin-top: 12px;
        p {
          background: var(--tip-content-bg);
          border-radius: 8px;
          padding: 8px 12px;
          font-size: 12px;
          font-weight: 500;
          color: #ff7114;
        }
      }

      .details-content {
        display: flex;
        // height: 466px;
        height: 454px;
        margin-top: 18px;
        padding-bottom: 20px;
        &.isPadding {
          padding-bottom: 0px;
          // height: 446px;
          height: 434px;
        }

        .tips-content-mobile {
          display: none;
        }

        .withdraw-income-mobile {
          display: none;
        }

        .line-chart-wrap {
          width: 409px;
          padding: 16px;
          height: 100%;
          // background-color: var(--tabs-bg);
          border-radius: 12px;

          // &.bar-chart-wrap {
          border: 1px solid var(--fold-border);
          background-color: var(--fold-bg);
          // }
        }

        .line-chart-info {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .line-chart-title {
            color: var(--color);
            font-size: 14px;
            font-weight: 500;
          }

          .tabs {
            transform: scale(0.83);
            transform-origin: right;
            font-size: 12px;
            border-radius: 5px;
            .tab {
              padding: 2px 13px;
              border-radius: 5px;
              white-space: nowrap;
            }
          }
        }

        #line-chart,
        #bar-chart {
          height: 100%;
          width: 100%;
        }

        .stake-wrap {
          padding-left: 16px;
          flex: 1;
          display: flex;
          flex-direction: column;

          .stake-history {
            margin-bottom: 16px;
            height: 52px;
            line-height: 52px;
            border-radius: 8px;
            border: 1px solid var(--fold-border);
            background-color: var(--fold-bg);
            padding-left: 16px;
            font-size: 14px;
            color: var(--color);
            font-weight: 500;

            display: flex;
            align-items: center;
            justify-content: space-between;

            &-confirming {
              margin-right: 36px;
              height: 29px;
              line-height: 29px;
              background: var(--keypal-bg);
              border-radius: 6px;
              padding: 0 12px;
              font-size: 12px;
              color: var(--keypal-title-color);
              font-weight: 500;
            }
          }

          .tabs {
            margin: 0 auto;
            .tab {
              padding: 0 30px;
              text-align: center;
              height: 32px;
              line-height: 32px;
              font-size: 12px;
            }
          }

          .unstake-type-wrap {
            margin-top: 20px;
            display: flex;
            align-items: center;
            .unstake-btn {
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              &:nth-child(2) {
                margin-left: 24px;
              }
              span {
                font-size: 13px;
                font-weight: 500;
                color: var(--details-overview-label-color);
                &.active {
                  color: var(--color);
                }
              }
              .bottom-line {
                margin-top: 6px;
                width: 24px;
                height: 2px;
                background: var(--color);
                border-radius: 2px;
                opacity: 1;
                &.show {
                  opacity: 0;
                }
              }
            }
          }

          .stake-content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            font-size: 14px;

            .remaining {
              display: flex;
              align-items: center;
              margin-top: 42px;
              margin-left: 12px;

              &-label {
                font-size: 12px;
                color: white;
                font-weight: 600;
              }

              &-value {
                padding: 3px 8px;
                background: white;
                border-radius: 5px;
                color: #3a3b3d;
                font-size: 14px;
                font-weight: 700;
                margin-left: 3px;
              }
            }

            .stake-input-outer {
              margin-top: 12px;
              width: 378px;
              height: 187px;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              padding: 0 12px;

              &.zh-normal {
                background-image: url("../assets/stake-pc-zh.png");
              }
              &.en-normal {
                background-image: url("../assets/stake-pc-en.png");
              }
              &.zh-activity {
                background-image: url("../assets/stake-activity-pc-zh.png");
              }
              &.en-activity {
                background-image: url("../assets/stake-activity-pc-en.png");
              }

              .stake-input-wrap {
                margin: 28px 12px 0;
                height: 41px;
                background: #ffffff;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 12.5px;

                &.fix-margin {
                  margin-top: 96px;
                }

                .stake-input {
                  color: #3a3b3d;
                  font-size: 12px;
                  font-weight: 500;
                  padding: 0 12.5px;
                  flex: 1;

                  &::placeholder {
                    color: #d5d8db;
                    font-weight: 400;
                  }
                }

                .stake-unit {
                  color: #3a3b3d;
                  font-size: 12px;
                }
              }

              .stake-tip {
                margin-left: 12.5px;
                margin-top: 8px;
                font-size: 12px;
                color: #3a3b3d;
              }
            }

            .stake-agree {
              color: var(--input-unit-color);
              font-size: 12px;
              // margin-top: 16px;
              display: flex;
              align-items: center;

              &-check {
                width: 15px;
                min-width: 15px;
                margin-right: 8px;
                cursor: pointer;
              }

              &-uncheck {
                width: 15px;
                min-width: 15px;
                height: 15px;
                border-radius: 50%;
                border: 1px solid var(--self-hold-btn-bg);
                margin-right: 8px;
                cursor: pointer;
              }
            }

            .stake-confirm {
              background-color: #2980fe;
              border-radius: 12px;
              color: #ffffff;
              font-weight: 500;
              height: 46px;
              line-height: 46px;
              text-align: center;
              margin-top: 40px;
            }
          }

          .unstake-content {
            margin-top: 10px;
            flex: 1;
            display: flex;
            flex-direction: column;

            .unstake-input-outer {
              padding: 16px;
              border-radius: 12px;
              background-color: var(--unstake-bg);
              border: 1px solid var(--unstake-border);
              .unstake-type-wrap-mobile {
                display: none;
              }
            }

            .unstake-input-wrap {
              margin-top: 8px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 16.5px;
              height: 53px;
              border-radius: 12px;
              background-color: var(--unstake-input-bg);
              border: 1px solid var(--unstake-input-border);

              .unstake-input {
                font-size: 14px;
                font-weight: 400;
                flex: 1;
                padding-right: 16px;
                color: var(--input-unit-color);
                width: 100px;

                &::placeholder {
                  color: var(--input-placeholder-color);
                }
              }

              .unstake-unit {
                color: var(--input-unit-color);
                font-size: 14px;
                font-weight: 500;
              }
            }

            .unstake-tip-wrap {
              display: flex;
              align-items: center;
              // margin-top: 8px;
            }

            .unstake-withdraw-wrap {
              margin-top: 8px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .withdraw-left {
                width: auto;
                display: flex;
                align-items: center;
                span {
                  font-size: 14px;
                  // color: var(--details-overview-label-color);
                  color: var(--color);
                }
                img {
                  margin: 0 4px;
                  width: 16px;
                }
              }
              .withdraw-btn {
                background: var(--withdraw-bg);
                border-radius: 40px;
                padding: 4px 24px;
                font-size: 12px;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                &.disabled {
                  background: var(--withdraw-disabled-bg);
                }
              }
            }

            .handling-fee {
              font-size: 12px;
              color: var(--details-overview-label-color);
            }

            .unstake-tip {
              // color: var(--details-overview-label-color);
              color: var(--color);
              font-size: 14px;
            }

            .question {
              margin-left: 8px;
              width: 16px;
              height: 16px;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              position: relative;
              cursor: pointer;

              &-dark {
                background-image: url("../assets/question-dark.png");
              }

              &-day {
                background-image: url("../assets/question-day.png");
              }

              .quit-max-overview {
                width: 250px;
                height: fit-content;
                padding: 8px 12px;
                font-size: 12px;
                position: absolute;
                // left: 28px;
                right: 28px;
                top: 20px;
                bottom: 0;
                margin: auto;
                background-color: #71747a;
                color: #e6e9f0;
                border-radius: 10px;
                z-index: 199;

                &::after {
                  content: "";
                  width: 0;
                  height: 0;
                  border-width: 8px;
                  border-color: transparent transparent transparent #71747a;
                  border-style: solid;
                  position: absolute;
                  right: -15px;
                  top: 0;
                  bottom: 20px;
                  margin: auto;
                }
              }
            }

            .unstake-about {
              margin-top: 16px;
              font-size: 14px;
              color: var(--input-unit-color);
            }

            .unstake-submit {
              margin-top: auto;
              border-radius: 12px;
              background: var(--estimate-annual-color);
              height: 46px;
              line-height: 46px;
              text-align: center;
              font-size: 14px;
              color: var(--connect-color);
              font-weight: 500;
              width: 100%;
              margin-top: auto;
            }
          }
        }

        .details-right {
          margin-left: 16px;
          display: flex;
          flex-direction: column;
          flex: 1;

          &-top {
            flex: 1;
            border: 1px solid var(--fold-border);
            border-radius: 8px;
            background-color: var(--fold-bg);
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            height: 100%;
          }

          &-bottom {
            margin-top: 16px;
            height: 52px;
            border: 1px solid var(--fold-border);
            border-radius: 8px;
            background-color: var(--fold-bg);
            display: flex;
            align-items: center;
            color: var(--color);
            font-weight: 500;
            font-size: 14px;
            padding-left: 16px;
          }
        }

        .details-endpoint-status-wrap {
          border-bottom: 1px solid var(--fold-border);
          margin: 0 16px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          overflow-x: hidden;
        }

        .details-endpoint-status {
          height: 52px;
          display: flex;
          align-items: center;
          color: var(--color);
          font-weight: 500;
          font-size: 14px;

          &::after {
            right: 8px;
          }

          &-content {
            flex: 1;
            overflow-y: auto;
          }
        }

        .endpoint-wrap {
          padding: 4px 0;

          &:last-of-type {
            margin-bottom: 12px;
          }

          .endpoint {
            background: var(--input-bg);
            border-radius: 8px;
            padding: 12px 0;

            &-title {
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              font-weight: 500;
              padding: 0 16px;
            }

            &-status {
              display: flex;
              align-items: center;
              font-weight: 500;
              font-size: 12px;

              &-point {
                width: 4.5px;
                height: 4.5px;
                border-radius: 50%;
                margin-right: 3px;
              }

              &-0 {
                color: #ff7114;

                .endpoint-status-point {
                  background-color: #ff7114;
                }
              }

              &-1,
              &-2 {
                color: #50c79f;

                .endpoint-status-point {
                  background-color: #50c79f;
                }
              }

              &-3,
              &-4 {
                color: #2980fe;

                .endpoint-status-point {
                  background-color: #2980fe;
                }
              }

              &-5 {
                color: #f56459;

                .endpoint-status-point {
                  background-color: #f56459;
                }
              }
            }
            .endpoint-stake {
              margin: 8px 16px 0;

              &-info {
                display: flex;
                align-items: center;
                background-color: var(--endpoint-info-bg);
                border: 1px solid var(--endpoint-info-border);
                border-radius: 8px;
                // margin-top: 8px;
                // margin-bottom: 8px;
                padding: 11px 0;
                margin: 11px 16px;

                > div {
                  flex: 1;
                }
              }
              &-label {
                margin-left: 12px;
                font-size: 12px;
                color: var(--endpoint-info-label);
                padding-right: 10px;
              }
              &-value {
                margin-left: 12px;
                margin-top: 3px;
                font-size: 13px;
                font-weight: 600;
              }
            }
            .endpoint-line {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 4px;
              color: var(--endpoint-line-color);
              font-size: 12px;
              padding: 0 16px;
              &-left,
              &-right {
                display: flex;
                align-items: center;

                img {
                  margin-left: 4px;
                  cursor: pointer;
                  width: 11.5px;
                }
              }
            }
            .endpoint-unstake-line {
              margin-top: 8px;
              display: flex;
              justify-content: flex-end;
              padding: 0 16px;
              .button {
                background: var(--withdraw-mobile-bg);
                border-radius: 25px;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: center;
                color: #fff;
                padding: 6px 23px;
                cursor: pointer;
              }
            }
            .line {
              width: 100%;
              height: 1px;
              background: var(--mobile-split-color);
              margin: 8px 0;
            }
            .receive-time {
              margin-bottom: 0;
            }
          }
        }

        .endpoint-no-data {
          flex: 1;
          text-align: center;

          img {
            width: 72px;
            margin-top: 64px;
          }

          p {
            text-align: center;
            color: var(--no-data-color);
            font-size: 13px;
            margin-top: 6px;
          }
        }

        .details-stake-history {
          height: 52px;
          display: flex;
          align-items: center;
          color: var(--color);
          font-weight: 500;
          font-size: 14px;
          padding-left: 16px;

          &-item {
            background: var(--input-bg);
            padding: 12px 32px 12px 16px;
            margin: 4px 16px;
            border-radius: 12px;
            display: flex;
            align-items: center;

            &:last-of-type {
              margin-bottom: 12px;
            }

            img {
              width: 30px;
              margin-right: 8px;
            }

            &.fold-wrap {
              &::after {
                right: 16px;
              }
            }
          }

          &-wrap {
            display: flex;
            flex-direction: column;
            overflow-y: auto;
          }

          &-content {
            flex: 1;
            overflow-y: auto;
          }

          &-no-data {
            flex: 1;
            text-align: center;

            img {
              width: 72px;
              margin-top: 64px;
            }

            p {
              text-align: center;
              color: var(--no-data-color);
              font-size: 13px;
              margin-top: 6px;
            }
          }
        }

        .self-host-stake {
          &-title {
            color: var(--history-title-color);
            font-size: 13px;
            font-weight: 500;
          }
          &-time {
            color: var(--history-time-color);
            font-size: 12px;
          }
          &-amount {
            margin-left: auto;
            color: var(--history-title-color);
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          }
        }

        .open {
          flex: 1;

          > .fold-wrap::after {
            rotate: 90deg;
          }
        }
      }

      .history-wrap {
        position: absolute;
        right: 0;
        top: 0;
        width: 408px;
        background-color: var(--history-bg);
        border-radius: 8px;
        height: 100%;
        padding: 22px 16px;
        transform: translateX(408px);
        transition-property: transform;
        transition-duration: 0.7s;
        display: flex;
        flex-direction: column;
        z-index: 99;

        &.open {
          transform: translateX(0);
          box-shadow: var(--history-shadow);
          transition-property: transform;
          transition-duration: 0.7s;
        }

        .history-title-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .history-title,
          .mobile-stake-page-title {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--details-overview-value-color);
          }

          .history-arrow {
            width: 24px;
            cursor: pointer;
          }
        }

        .history-list {
          margin-top: 16px;
          flex: 1;
          overflow: auto;
          // cursor: pointer;
          .history-item {
            margin-bottom: 8px;
            padding: 12px 32px 12px 16px;
            background: var(--input-bg);
            border-radius: 12px;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            &.withdraw-arrow {
              &::after {
                content: ">";
                transform: scale(0.5, 1.2);
                transform-origin: right center;
                color: var(--history-enter-color);
                position: absolute;
                right: 16px;
                top: 0;
                bottom: 0;
                margin: auto;
                height: fit-content;
              }
            }

            &-status {
              width: 30px;
              margin-right: 8px;
            }

            &-title {
              font-size: 13px;
              font-weight: 500;
              color: var(--history-title-color);
            }

            &-time {
              color: var(--history-time-color);
              font-size: 12px;
            }

            &-right {
              color: var(--history-title-color);
              font-weight: 500;
              font-size: 14px;
              margin-left: auto;
            }
          }
        }

        .history-no-data {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 150px;

          img {
            display: block;
            width: 72px;
          }
          p {
            text-align: center;
            color: var(--no-data-color);
            font-size: 13px;
            margin-top: 6px;
          }
        }
      }
    }

    .self-host-stake-wrap {
      display: flex;
      flex-direction: column;

      .self-host-stake {
        &-block {
          margin-top: 12px;
          border-radius: 14px;
          border: 1px solid var(--fold-border);
          background-color: var(--fold-bg);

          .need-balance {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: var(--details-overview-label-color);
            font-size: 14px;
          }
        }
        &-block1 {
          margin-top: 16px;
          padding: 16px;
        }

        &-warn {
          padding: 10px 16px;
          border-radius: 8px;
          background: var(--details-total-income-bg);
          color: var(--details-total-income-color);
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;

          img {
            margin-right: 10px;
            height: 19px;
          }
        }
        &-endpoint-amount {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: var(--color);
          width: 100%;
          margin-top: 18px;

          &-title {
            font-weight: 500;
            font-size: 14px;
          }

          &-right {
            display: flex;
            align-items: center;

            .minus,
            .plus {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              font-size: 20px;
              font-weight: 500;
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--color);
              background-color: var(--mobile-overview-total-income-bg);
              cursor: pointer;
            }

            .amount {
              margin: 0 24px;
            }
            button:disabled {
              opacity: 1;
              color: var(--history-enter-color);
            }
          }
        }

        &-title {
          color: var(--details-overview-value-color);
          margin-top: 16px;
          font-size: 14px;
          font-weight: 500;
        }

        &-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 14px;

          &-label {
            color: var(--color);
            font-weight: 500;
          }

          &-right {
            color: var(--details-overview-label-color);
            font-weight: 400;
            display: flex;
            align-items: center;
            padding-right: 16px;

            img {
              height: 22px;
              margin-left: 4px;
              cursor: pointer;
            }
          }

          &-content {
            text-align: right;
            padding-right: 16px;
          }

          &-cal {
            font-size: 12px;
            color: var(--details-overview-label-color);
          }

          &-sum {
            color: var(--color);
          }
        }

        &-block2 {
          padding: 16px 0 8px 16px;

          .self-host-stake-item-question {
            width: 20px;
            height: 20px;
            background: url("../assets/question.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            cursor: pointer;

            &-tip {
              width: 250px;
              height: fit-content;
              padding: 8px 12px;
              font-size: 12px;
              position: absolute;
              right: 28px;
              top: 0;
              bottom: 0;
              margin: auto;
              background-color: #71747a;
              color: #e6e9f0;
              border-radius: 10px;
              z-index: 199;

              &::after {
                content: "";
                width: 0;
                height: 0;
                border-width: 8px;
                border-color: transparent transparent transparent #71747a;
                border-style: solid;
                position: absolute;
                right: -15px;
                top: 0;
                bottom: 0;
                margin: auto;
              }

              &-bg {
                display: none;
              }
            }
          }
        }

        &-split {
          height: 1px;
          background-color: var(--fold-border);
          margin-bottom: 8px;
        }

        &-pay-wrap {
          margin-top: auto;
        }

        &-agree-wrap {
          display: flex;
          align-items: center;

          span {
            font-size: 12px;
            color: var(--input-unit-color);
            margin-left: 8px;
          }
        }

        &-agree-uncheck {
          height: 15px;
          width: 15px;
          min-width: 15px;
          border-radius: 50%;
          border: 1px solid var(--self-hold-btn-bg);
        }

        &-agree-check {
          width: 15px;
          min-width: 15px;
        }

        &-confirm {
          margin-top: 15.5px;
          height: 46px;
          border-radius: 8px;
          color: #ffffff;
          background: var(--pay-confirm-bg);
        }

        &-keypal {
          height: 36px;
          border-radius: 8px;
          margin-right: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 8px;
          font-size: 12px;
          background-color: var(--keypal-bg);
          margin-bottom: 20px;
          cursor: pointer;

          &-left {
            display: flex;
            align-items: center;

            img {
              width: 20px;
              margin-right: 1.5px;
            }

            span {
              font-weight: 500;
              color: var(--keypal-title-color);
            }
          }

          &-right {
            color: var(--keypal-subtitle-color);
            display: flex;
            align-items: center;

            .arrow {
              transform: scale(0.5, 1.2) translateY(-1.5px);
            }
          }
        }
      }
    }
  }

  .tabs {
    display: flex;
    padding: 3.5px;
    color: var(--color);
    background-color: var(--tabs-bg);
    border-radius: 10px;
    width: fit-content;

    .tab {
      font-size: 14px;
      border-radius: 10px;
      // white-space: nowrap;
      cursor: pointer;

      &.checked {
        background: var(--tab-checked-bg);
        box-shadow: 0px 2.35px 0.78px 0px rgba(94, 136, 174, 0.04),
          0px 2.35px 6.28px 0px rgba(69, 116, 170, 0.12);
        // font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
      }
    }
  }

  .fold-wrap {
    position: relative;
    cursor: pointer;
    &::after {
      content: ">";
      transform: scale(0.5, 1.2) translateY(-1.5px);
      transform-origin: right center;
      color: var(--history-enter-color);
      position: absolute;
      right: 24px;
      top: 0;
      bottom: 0;
      margin: auto;
      height: fit-content;
    }
  }

  .mobile-stake-unstake-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .self-host-stake-keypal {
    &-cover {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 199;
    }

    &-popover {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      height: fit-content;
      background-color: var(--settings-bg);
      width: 448px;
      border-radius: 20px;
      padding: 25px 32px;
      max-height: 95vh;
      overflow-y: auto;

      &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 17px;

        img {
          width: 32px;
          cursor: pointer;
        }
      }

      &-title {
        color: var(--keypal-popover-title-color);
        font-weight: 600;
        font-size: 20px;
      }

      &-item {
        margin-bottom: 8px;
        p {
          color: var(--color);
          font-size: 14px;
          font-weight: 500;
        }
        input {
          height: 48px;
          border-radius: 16px;
          background-color: var(--keypal-popover-input-bg);
          width: 100%;
          margin-top: 4px;
          padding: 0 16px;
          color: var(--color);
          font-weight: 500;

          &::placeholder {
            color: var(--keypal-popover-placeholder-color);
          }
        }

        textarea {
          height: 108px;
          border-radius: 16px;
          width: 100%;
          margin-top: 4px;
          padding: 12px 16px;
          background-color: var(--keypal-popover-input-bg);
          color: var(--color);
          border: none;
          font-weight: 500;
          resize: none;

          &::placeholder {
            color: var(--keypal-popover-placeholder-color);
          }
        }
      }

      button {
        margin-top: 16px;
        border-radius: 90px;
        height: 48px;
        background-color: var(--pay-confirm-bg);
        color: #ffffff;
        width: 100%;
        font-size: 16px;
        font-weight: 500;
      }

      .phone-wrap {
        display: flex;
        align-items: center;
        height: 48px;
        border-radius: 16px;
        background-color: var(--keypal-popover-input-bg);
        position: relative;
        margin-top: 4px;

        input {
          margin-top: 0;
        }
      }

      .phone-split {
        height: 18px;
        width: 1px;
        background-color: var(--history-enter-color);
        margin-left: 8px;
      }

      .country-code-wrap {
        .country-code {
          display: flex;
          align-items: center;
          padding-left: 16px;
          cursor: pointer;

          &-name {
            font-weight: 500;
            font-size: 14px;
            white-space: nowrap;
            color: var(--color);
          }

          &-expand {
            transform: scale(1.2, 0.5) rotate(90deg);
            color: var(--keypal-popover-placeholder-color);
            margin-left: 4px;
            display: flex;
            font-size: 14px;

            &1 {
              margin-right: 3px;
            }
          }
        }
      }

      .country-code-list {
        &-wrap {
          position: absolute;
          left: 0;
          top: 48px;
          width: fit-content;
          height: 200px;
          padding: 16px 0;
          background-color: var(--country-code-wrap-bg);
          border: 1px solid var(--country-code-wrap-border);
          border-radius: 12px;
          box-shadow: 0px 6px 16px 0px rgba(45, 54, 86, 0.05);
          overflow-y: auto;
          cursor: pointer;
        }
        &-item {
          padding: 8px 32px;
          font-weight: 500;
          color: var(--input-unit-color);

          &:hover {
            background-color: var(--country-code-wrap-hover-bg);
          }
        }
      }
    }
  }
  .download-popover-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 299;
  }
  .download-popover {
    width: 448px;
    height: fit-content;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 25px 32px;
    background: var(--settings-bg);
    border-radius: 20px;
    box-shadow: 0px 64px 64px -48px rgba(31, 47, 70, 0.12);

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-title {
      color: var(--keypal-popover-title-color);
      font-weight: 600;
      font-size: 20px;
    }

    &-close {
      cursor: pointer;
      width: 32px;
    }

    &-desc {
      font-size: 14px;
      font-weight: 500;
      color: var(--history-time-color);
      margin-top: 9px;
    }

    &-download {
      margin-top: 24px;

      &-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
      }

      &-explorer {
        height: 28px;
      }

      &-copy {
        cursor: pointer;
        height: 14px;
      }

      a {
        margin: 0 8px;
        color: var(--pay-confirm-bg);
        font-size: 14px;
        font-weight: 500;
      }
    }

    &-confirm {
      margin-top: 28px;
      background-color: var(--pay-confirm-bg);
      color: #ffffff;
      font-size: 16px;
      font-weight: 700;
      height: 48px;
      border-radius: 24px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 700px) {
  // .title,
  // .content {
  //   width: 100% !important;
  // }

  .stake-vault {
    // width: auto;
    // min-width: 0;
    background-size: 100vw auto;
    background-repeat: no-repeat;
    background-position-y: 15px;

    &.day.en {
      background-image: url("../assets/day-en-mobile.png");
    }

    &.dark.en {
      background-image: url("../assets/dark-en-mobile.png");
    }

    &.day.zh {
      background-image: url("../assets/day-zh-mobile.png");
    }

    &.dark.zh {
      background-image: url("../assets/dark-zh-mobile.png");
    }

    .cover {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 19;
    }

    .header {
      display: none;

      &.header-visible {
        display: block;
        position: fixed;
        left: 24px;
        right: 24px;
        top: 0;
        bottom: 0;
        margin: auto;
        height: fit-content;
        z-index: 29;
        border-radius: 19px;
        background-color: var(--settings-bg);
        box-shadow: 0px 122.03px 122.03px -91.52px var(--settings-box-shadow);
        padding: 25px 24px 36px;

        .logo {
          display: none;
        }
      }
      .header-right {
        flex-direction: column-reverse;

        .mobile-settings {
          &-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 21px;
            width: 100%;
          }

          &-title {
            font-size: 20px;
            font-weight: 600;
            color: var(--input-unit-color);
          }

          &-close {
            height: 32px;
            cursor: pointer;
          }
        }

        .mode-wrap {
          justify-content: space-between;
          width: 100%;
          .moon {
            display: none;
          }
          .mode {
            color: var(--input-unit-color);
          }
          .mode-switcher {
            .weui-switch {
              &::after {
                background-color: #c0c3c6;
              }
            }
          }
        }
        .locale-outer {
          width: 100%;
          margin-bottom: 33px;
          padding-top: 22px;
          border-top: var(--settings-border) 1px solid;
        }
        .locale-wrap {
          justify-content: space-between;
          color: var(--settings-value-color);
          width: 100%;
          margin-left: 0;

          .locale-label {
            color: var(--input-unit-color);
          }
          .locale {
            font-weight: 400;
          }
          .locale-arrow {
            rotate: 0deg;
            transform: translateY(-1.4px) scale(0.5, 1.2);
          }
          img {
            display: none;
          }
        }
        .locale-menu {
          display: none;
        }
        .locale-menu-mobile {
          position: fixed;
          left: 24px;
          right: 24px;
          top: 0;
          bottom: 0;
          margin: auto;
          height: fit-content;
          z-index: 39;
          border-radius: 19px;
          background-color: var(--settings-bg);
          box-shadow: 0px 122.03px 122.03px -91.52px var(--settings-box-shadow);
          padding: 25px 24px 28px;

          &-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: var(--settings-border) 1px solid;
          }

          &-back {
            color: var(--input-unit-color);
            transform: scale(0.5, 1.2) translateY(-1.5px);
            font-size: 24px;
          }

          &-item {
            color: var(--settings-value-color);
            padding: 24px 0 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &::after {
              content: ">";
              transform: scale(0.5, 1.2) translateY(-1.4px);
              color: var(--history-enter-color);
            }
          }
        }
      }
    }

    .title {
      width: 100vw;
      border-radius: 0;
      overflow: hidden;
      font-size: 12px;
      margin: 0;

      img {
        display: none;
      }

      span {
        white-space: nowrap;
        animation: 20s wordsLoop linear infinite normal;
      }

      @keyframes wordsLoop {
        0% {
          transform: translateX(100vw);
          -webkit-transform: translateX(100vw);
        }
        100% {
          transform: translateX(-100%);
          -webkit-transform: translateX(-100%);
        }
      }
    }

    .settings {
      position: absolute;
      right: 0;
      top: 43.5px;
      background-color: rgba(255, 255, 255, 0.4);
      padding: 3px 6px 3px 12px;
      border-radius: 12px 0 0 12px;
      font-size: 13px;
      font-weight: 500;
      color: white;
      cursor: pointer;
    }

    .content {
      display: block;
      width: 100%;
      height: auto;

      .left {
        width: 100%;
        margin-top: calc(28vw - 17.5px);
        .overview {
          height: auto;
          background-color: transparent;
          padding: 4vw 8vw 0;

          .account-info {
            .account {
              margin-left: 8px;
            }

            .balance-wrap {
              display: none;
            }

            &.en {
              .account-wrap {
                flex-direction: column;
                align-items: unset;
              }

              .account-switch {
                margin-left: 8px;
                margin-top: 0;
                padding-top: 0;
                padding-bottom: 0;
              }
            }
          }

          .connect {
            height: 36px;
            line-height: 36px;
            padding: 0 63px;
            width: fit-content;
            background: rgba(230, 233, 240, 0.56);
            border-radius: 8px;
            font-size: 15px;
          }

          .switch {
            height: 36px;
            line-height: 36px;
            padding: 0 17px;
            width: fit-content;
            border-radius: 8px;
            font-size: 15px;
          }

          .overview-staked {
            background-image: none !important;
            margin-top: 4vw;
            background-color: var(--mobile-overview-bg);
            display: flex;
            height: auto;
            border-radius: 10px;
            padding-bottom: 80px;

            .split-line {
              display: none;
            }
            .total-staked {
              height: auto;
              padding-top: 0;
              margin: 0;
              width: 34%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .staked-label {
                color: var(--mobile-overview-label-color);
                font-size: 12px;
                margin-right: 5px;
                margin-left: 16px;
              }

              .staked-value {
                color: var(--mobile-overview-value-color);
                font-size: 20px;
                margin-right: 5px;
                margin-left: 16px;
              }
            }

            .self-host-staked,
            .joint-staked {
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .staked-label {
                color: var(--mobile-overview-label-color);
                font-size: 12px;
                // margin-right: 0;
                margin-right: 5px;
                margin-left: 16px;
                // margin: 0;
              }

              .staked-value {
                color: var(--mobile-overview-value-color);
                font-size: 20px;
                margin-right: 5px;
                margin-left: 16px;
                // margin: 0;
              }
            }
          }

          .total-income {
            margin-top: -66px;
            border-radius: 8px;
            background-color: var(--mobile-overview-total-income-bg);
            height: 49px;
            margin: -66px 16px 0;

            &-label {
              color: var(--mobile-overview-total-income-label-color);
              font-size: 12px;
            }

            &-value {
              color: var(--mobile-overview-value-color);
              font-size: 16px;
            }
          }
        }

        .mobile-stake-wrap {
          margin-top: 39px;
          margin-bottom: 12px;
          padding: 0 16px;
        }

        .mobile-stake {
          &-title {
            padding-left: 2px;
            font-size: 16px;
            font-weight: 600;
            color: var(--mobile-overview-value-color);
          }

          &-content {
            border-radius: 10px;
            background-color: var(--mobile-overview-bg);
            margin-top: 12px;
          }

          &-self-host,
          &-joint {
            padding: 16px 30px 16px 20px;
            position: relative;

            &::after {
              content: ">";
              transform: scale(0.5, 1.2);
              position: absolute;
              font-size: 20px;
              color: var(--history-enter-color);
              right: 20px;
              top: 0;
              bottom: 0;
              margin: auto;
              height: fit-content;
            }
          }

          &-split {
            margin-left: 18.5px;
            height: 1px;
            background-color: var(--mobile-split-color);
          }

          &-label {
            color: var(--mobile-overview-value-color);
            font-size: 14px;
            font-weight: 500;
          }

          &-desc {
            color: var(--mobile-overview-label-color);
            font-size: 12px;
            margin-top: 4px;
          }

          &-line {
            display: flex;
            align-items: center;
          }

          &-new {
            background: linear-gradient(180deg, #ff5757, #ff9e57 100%);
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
            color: white;
            padding: 2px 8px;
            margin-left: 8px;
          }
        }

        .knowledge {
          background: transparent;
          margin-top: 24px;
          padding: 0 16px;

          &-title {
            color: var(--mobile-overview-value-color);
            font-size: 16px;
          }

          &-item {
            font-size: 14px;
            color: var(--mobile-overview-value-color);
            background-color: var(--mobile-overview-bg);
            padding: 20px;
            height: auto;
            line-height: initial;
            margin-top: 0;
            border-radius: 0;

            &:first-of-type {
              border-radius: 10px 10px 0 0;
              margin-top: 8px;
            }
            &:last-of-type {
              border-radius: 0 0 10px 10px;
              // margin-top: 0;
            }

            &::after {
              content: ">";
              transform: scale(0.5, 1.2);
              position: absolute;
              font-size: 20px;
              color: var(--history-enter-color);
              right: 20px;
              top: 0;
              bottom: 0;
              margin: auto;
              height: fit-content;
            }

            &::before {
              content: "";
              height: 1px;
              background-color: var(--mobile-split-color);
              position: absolute;
              width: calc(100% - 18px);
              bottom: 0;
            }
          }

          &-split {
            margin-left: 18.5px;
            height: 1px;
            background-color: var(--fold-border);
          }
        }
      }

      .right {
        &-cover {
          display: none;
        }

        &.mobile-hidden {
          display: none;
        }

        .details-joint {
          .details-overview {
            margin: 28px 32px 0;
            border-radius: 10px;
            background-color: var(--mobile-overview-total-income-bg);
            height: 75px;
            position: relative;

            .label {
              font-size: 12px;
              text-align: center;
            }

            .total-income .value {
              color: var(--details-overview-value-color);
              padding: 0;
              background-color: transparent;
            }
            .withdraw-income {
              display: none;
            }

            > div .value {
              font-size: 18px;
            }
          }
          .tips-content {
            display: none;
          }
          .details-content {
            display: block;
            height: auto;
            margin-top: -91px;

            .tips-content-mobile {
              display: block;
              margin-top: 0;
              p {
                margin-top: 0;
              }
              .line {
                display: block;
              }
            }
            
            .withdraw-income-mobile {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 20px;
              .withdraw-income-left {
                display: flex;
                flex-direction: column;
                .withdraw-income-content {
                  display: flex;
                  align-items: center;
                  span {
                    font-size: 14px;
                    font-weight: 500;
                    color: var(--color);
                  }
                  img {
                    margin: 0 4px;
                    width: 16px;
                  }
                }
                .estimate-gas {
                  margin-top: 4px;
                  font-size: 12px;
                  color: var(--details-overview-label-color);
                  font-weight: 400;
                }
              }
              .withdraw-income-btn {
                background: var(--withdraw-mobile-bg);
                border-radius: 40px;
                padding: 5px 20px;
                font-size: 11px;
                font-weight: 600;
                text-align: center;
                color: #ffffff;
                white-space: nowrap;
                &.disabled {
                  background: var(--withdraw-mobile-disabled-bg);
                }
              }
            }

            .line {
              margin: 20px 0 16px;
              height: 1px;
              background: var(--fold-border);
            }

            .line-chart-wrap {
              width: auto;
              background-color: var(--mobile-overview-bg);
              margin: 0 16px;
              padding-top: 91px;
              border: none;

              #line-chart {
                width: calc(100vw - 64px);
                height: 137.5px;
                margin-top: 4px;
              }
            }
            .stake-wrap {
              > .tabs {
                display: none;
              }
              .mobile-stake-unstake-wrap {
                .joint-stake-mobile-content {
                  .tabs {
                    display: flex !important;
                    background: rgba(255, 255, 255, 0.32);
                    margin-top: 32px;

                    .tab {
                      font-weight: 600;
                      height: 34px;
                      line-height: 34px;
                      color: #ffffff;
                      font-size: 13px;

                      &.checked {
                        color: var(--color);
                      }
                    }
                  }
                }
                .stake-input-outer {
                  width: auto;
                  margin: 23px 16px 0;
                }

                .stake-agree {
                  margin: auto 24px 0;
                }
                .stake-confirm {
                  margin: 17.5px 24px 50px 24px;
                }
              }

              .unstake-type-wrap {
                display: none;
              }

              .unstake-content {
                margin-top: 20px;
                .unstake-input-outer {
                  background-color: var(--mobile-overview-bg);
                  margin: 0 16px;
                  border: none;
                  padding: 20px 19.5px 20px 15.5px;
                  .unstake-type-wrap-mobile {
                    display: flex;
                    margin-top: 0;
                    margin-bottom: 16px;
                    .unstake-btn {
                      span {
                        font-size: 14px;
                      }
                    }
                  }

                  .unstake-tip-wrap {
                    // img {
                    //   display: none;
                    // }
                    .question {
                      .quit-max-overview {
                        position: fixed;
                        left: 8vw;
                        right: 8vw;
                        top: 0;
                        bottom: 0;
                        width: auto;
                        padding: 20px;
                        z-index: 199;
                        font-size: 16px;
                        text-align: center;
                        background-color: var(--quit-max-overview-bg);
                        color: var(--mobile-overview-label-color);
                        font-weight: 400;

                        &::after {
                          display: none;
                        }
                      }

                      &.question-pc {
                        display: none;
                      }
                    }

                    .quit-max-overview-bg {
                      z-index: 198;
                      position: fixed;
                      background: rgba(0, 0, 0, 0.7);
                      width: 100%;
                      height: 100%;
                      left: 0;
                      top: 0;
                    }
                  }
                  .unstake-withdraw-wrap {
                    margin-top: 12px;
                    .withdraw-left {
                      span {
                        font-size: 14px;
                      }
                    }
                    .withdraw-btn {
                      background: var(--withdraw-mobile-bg);
                      &.disabled {
                        background: var(--withdraw-mobile-disabled-bg);
                      }
                    }
                  }
                }
                .unstake-about {
                  margin: 20px 18px 0;
                }
                .unstake-submit {
                  margin: auto 24px 50px;
                  width: auto;
                }
              }
            }

            .stake-unstake {
              margin-right: 16px;
              border-radius: 10px 10px 0 0;
              margin-top: 12px;
              height: 52px;
              line-height: 52px;
              border: 1px solid var(--fold-border);
              background-color: var(--mobile-overview-bg);
              padding-left: 16px;
              font-size: 14px;
              color: var(--color);
              font-weight: 500;
              border-top: none;
              border-left: none;
              border-right: none;

              &::after {
                font-size: 16px;
              }
            }

            .stake-history {
              margin-right: 16px;
              margin-bottom: 12px;
              border-radius: 0 0 10px 10px;
              border-top: none;
              border: none;
              background-color: var(--mobile-overview-bg);

              &::after {
                font-size: 18px;
              }

              &-confirming {
                height: 25px;
                padding: 0 8px;
              }
            }
            .common-question {
              margin-right: 16px;
              border-radius: 10px;
              height: 52px;
              line-height: 52px;
              border: 1px solid var(--fold-border);
              background-color: var(--mobile-overview-bg);
              font-size: 14px;
              color: var(--color);
              font-weight: 500;
              padding-left: 16px;
              border: none;

              &::after {
                font-size: 16px;
              }
            }
          }
          .history-wrap {
            width: 100%;
            border-radius: 0;
            transition: none;
            display: none;

            &.open {
              display: block;
            }

            .history-arrow {
              display: none;
            }

            .history-title-wrap {
              display: none;
            }

            .history-list {
              margin-top: 8px;
              padding: 0 16.5px;

              .history-item {
                margin-bottom: 12px;
                background-color: var(--mobile-overview-bg);
                color: var(--color);
              }
            }

            .history-no-data {
              margin: 24px 16px;
              background: var(--mobile-overview-bg);
              padding: 90px 20px;
              border-radius: 12px;

              img {
                margin: 0;
              }
            }
          }

          &.en {
            .details-overview {
              height: 100px;

              .estimate-annualized {
                top: 110.5px;
              }

              > div {
                .label {
                  padding: 0 10px;
                }
              }
            }

            .details-content {
              .line-chart-wrap {
                margin-top: -110.5px;
                padding-top: 126.5px;
              }
            }
          }
        }

        .details-self-host {
          .details-overview {
            margin: 26px 32px 0;
            height: 102px;
            position: relative;
            background-color: var(--mobile-overview-total-income-bg);

            > div {
              .label {
                font-size: 12px;
                // opacity: 0.7;
                text-align: center;
              }
              .go-endpoint {
                display: flex;
                align-items: center;
                span {
                  font-size: 12px;
                  color: var(--endpoint-line-color);
                }
                img {
                  margin-left: 2px;
                  width: 10px;
                  height: 10px;
                }
              }
              .value {
                font-size: 18px;
                padding: 0 20px;
              }

              &.estimate-annualized {
                position: absolute;
                top: 115.5px;
                flex-direction: row;
                width: 100%;

                .label {
                  opacity: 1;
                  color: var(--estimate-annual-color);
                  margin: 0;
                  position: relative;

                  &::after {
                    content: ":";
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: -5px;
                    margin: auto;
                  }
                }
                .value-wrap {
                  justify-content: space-between;
                  flex: 1;
                  .value {
                    margin-left: 15px;
                    font-size: 20px;
                    padding: 0;
                  }
                  .self-host-btn {
                    padding: 8px 24px;
                    font-size: 14px;
                    margin: 0;
                  }
                }
              }
            }
          }
          .details-content {
            display: block;
            margin: 0;
            padding: 0;
            height: auto;

            .line-chart-wrap {
              background-color: var(--mobile-overview-bg);
              margin: -115.5px 16px 0;
              width: auto;
              height: 380px;
              display: flex;
              flex-direction: column;
              border: none;

              .line-chart-info {
                margin-top: 175px;
                padding-top: 16px;
                border-top: 1px var(--mobile-split-color) solid;

                .bar-chart-wrap {
                  flex: 1;
                }
              }
            }

            .details-right {
              &-top {
                margin-right: 16px;
                margin-top: 12px;
                border: none;
                background-color: var(--mobile-overview-bg);

                .details-endpoint-status-content,
                .details-stake-history-content {
                  .mobile-endpoint-title {
                    margin: 12px 16px 8px;
                    font-size: 16px;
                    font-weight: 500;
                    color: white;
                  }
                }
                .details-stake-history {
                  &-item {
                    background-color: var(--mobile-overview-bg);
                    margin: 6px 15.5px;

                    img {
                      margin-right: 12px;
                      width: 32.5px;
                    }

                    .self-host-stake-left {
                      .self-host-stake-title {
                        font-size: 14px;
                      }
                    }
                  }

                  &-no-data {
                    margin: 12px 16px;
                    background: var(--mobile-overview-bg);
                    padding: 90px 20px;
                    border-radius: 12px;

                    img {
                      margin: 0;
                    }
                  }
                }
                .endpoint-wrap {
                  margin: 0 16px;

                  .endpoint {
                    // padding: 16px;
                    background-color: var(--mobile-overview-bg);
                  }
                  .endpoint-name {
                    font-size: 14px;
                  }
                  .endpoint-status-title {
                    font-size: 13px;
                  }
                  .endpoint-stake-info {
                    margin-top: 12px;
                    margin-bottom: 12px;
                    padding: 14.5px 0;
                    background-color: var(--mobile-overview-total-income-bg);

                    .endpoint-stake-value {
                      margin-left: 17px;
                    }
                  }
                  .endpoint-line {
                    img {
                      width: 15px;
                    }
                  }
                }
                .endpoint-no-data {
                  margin: 12px 16px;
                  background: var(--mobile-overview-bg);
                  padding: 90px 20px;
                  border-radius: 12px;

                  img {
                    margin: 0;
                  }
                }
              }
              &-bottom {
                margin-right: 16px;
                margin-top: 12px;
                margin-bottom: 20px;
                border: none;
                background-color: var(--mobile-overview-bg);
              }
            }
          }

          .history-wrap {
            transition: none;
            width: 100%;
            border-radius: 0;
            display: none;

            &.open {
              display: block;
            }

            .history-title-wrap {
              text-align: center;
              padding: 12px 0;
              color: white;
              position: relative;
              justify-content: center;

              &-back {
                font-size: 24px;
                position: absolute;
                left: 20px;
                top: 7px;
                margin: auto;
                transform: scale(0.5, 1.2);
              }

              .history-title {
                font-size: 16px;
                font-weight: 600;
                color: white;
              }
              .history-arrow {
                display: none;
              }
            }
            .inner-stake-user-status {
              margin: 6px 16px 0;
            }
            .self-host-stake-block1 {
              margin: 12px 16px 0;
              padding: 16px 16px 24px;
              border: none;

              .self-host-stake-warn {
                padding: 8px;
                font-size: 13px;

                img {
                  height: 16px;
                  margin-right: 4px;
                }
              }
              .self-host-stake-endpoint-amount {
                &-right {
                  .minus,
                  .plus {
                    width: 20px;
                    height: 20px;
                    padding: 0;

                    span {
                      transform: translateY(-1px);
                    }
                  }
                  .amount {
                    font-size: 17px;
                    margin: 0 16px;
                  }
                }
                .need-balance {
                  margin-top: 16px;
                }
              }
            }
            .self-host-stake-title {
              margin-top: 24px;
              margin-left: 18px;
              font-size: 16px;
            }
            .self-host-stake-block2 {
              margin: 12px 16px 0;
              border: none;

              .self-host-stake-item {
                margin-bottom: 12px;
                &-question {
                  height: 20px;
                  width: 20px;

                  &-tip {
                    position: fixed;
                    left: 8vw;
                    right: 8vw;
                    top: 0;
                    bottom: 0;
                    width: auto;
                    padding: 20px;
                    z-index: 199;
                    font-size: 16px;
                    text-align: center;
                    background-color: var(--quit-max-overview-bg);
                    color: var(--mobile-overview-label-color);
                    font-weight: 500;

                    &::after {
                      display: none;
                    }

                    &-bg {
                      position: fixed;
                      left: 0;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      background: rgba(0, 0, 0, 0.6);
                      z-index: 39;
                      display: block;
                    }
                  }
                }
                &-cal {
                  font-size: 13px;
                }
                &-sum {
                  font-size: 15px;
                  font-weight: 500;
                }
                &-value {
                  text-align: right;
                }
              }
            }
            .self-host-stake-split {
              margin-top: 16px;
            }
            .self-host-stake-pay-wrap {
              margin: 30px 24px 0;

              span {
                font-size: 13px;
              }
            }
            .self-host-stake-confirm {
              margin: 17.5px 24px 50px;
              width: -webkit-fill-available;
            }
          }

          &.en {
            .details-overview {
              height: 100px;

              .estimate-annualized {
                top: 110.5px;
              }

              .total-stake {
                .label {
                  padding: 0 10px;
                }
              }
            }

            .details-content {
              .line-chart-wrap {
                margin-top: -110.5px;
              }
            }
          }
        }

        .mobile-inner-hidden {
          display: none !important;
        }

        .stake-type-tabs {
          display: none;
        }

        .mobile-stake-page {
          &-header {
            text-align: center;
            padding: 12px 0;
            color: white;
            position: relative;
          }

          &-back {
            font-size: 24px;
            position: absolute;
            left: 20px;
            top: 7px;
            margin: auto;
            transform: scale(0.5, 1.2);
          }

          &-title {
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }

    .as-page {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-repeat: no-repeat !important;
      background-size: 100% auto !important;
      background-color: var(--bg) !important;
      border-radius: 0 !important;
      padding: 0 !important;
      overflow-y: auto !important;
      z-index: 9 !important;

      &.mobile-day {
        background-image: url("../assets/mobile-day.png");
      }

      &.mobile-dark {
        background-image: url("../assets/mobile-dark.png");
      }
    }

    .joint-stake-overview {
      margin: 6px 16px 0;
      border-radius: 12px;
      background: var(--joint-staked-bg);

      .joint-stake-overview-staked {
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        color: var(--input-unit-color);
        font-weight: 500;

        &-label {
          font-size: 13px;
        }
        &-value {
          font-size: 15px;
        }
      }
    }
    .inner-stake-user-status {
      height: 72px;
      border-radius: 12px;
      background-color: var(--mobile-overview-bg);
      display: flex;
      align-items: center;
      padding: 0 16px;

      img {
        height: 40px;
      }

      .inner-stake-user {
        &-address {
          font-size: 15px;
          color: var(--input-unit-color);
          margin-left: 12px;
        }
        &-right {
          margin-left: auto;
          text-align: right;
        }
        &-value {
          color: var(--input-unit-color);
          font-size: 15px;
          font-weight: 500;
        }
        &-label {
          color: #9ea0a5;
          font-size: 12px;
        }
      }
    }
    .self-host-stake-keypal {
      &-popover {
        left: 5vw;
        right: 5vw;
        width: auto;
        padding: 24px;

        button {
          height: 48px;
          border-radius: 12px;
        }

        &-item {
          margin-bottom: 12px;
        }
      }
    }

    .download-popover {
      width: auto;
      left: 16px;
      right: 16px;
      border-radius: 12px;
      padding: 28px 20px;

      &-title {
        text-align: center;
      }

      &-close {
        // display: none;
      }

      &-desc {
        margin-top: 12px;
        font-size: 16px;
      }

      &-download {
        margin-top: 16px;

        &-item {
          margin-bottom: 12px;
        }

        a {
          font-size: 15px;
        }
      }

      &-confirm {
        margin-top: 24px;
        height: 48px;
        border-radius: 12px;
        font-weight: 500;
        font-size: 15px;
      }
    }
  }
  .fold-wrap {
    &::after {
      rotate: 0deg !important;
    }
  }
  .self-host-stake-item-question {
    &.pc {
      display: none;
    }
  }
}
@media screen and (min-width: 700px) {
  .stake-vault {
    .content {
      .right {
        .details-overview > div {
          justify-content: center;
          .go-endpoint {
            display: none;
          }
        }
      }
    }
  }
  .mobile-stake-wrap {
    display: none;
  }
  .knowledge-split {
    display: none;
  }
  .mobile-stake-page-header {
    display: none;
  }
  .stake-unstake {
    display: none;
  }
  .common-question {
    display: none;
  }
  .mobile-endpoint-title {
    display: none;
  }
  .joint-stake-mobile-content {
    display: none;
  }
  .history-title-wrap-back {
    display: none;
  }
  .mobile-settings-header {
    display: none;
  }

  .locale-label {
    display: none;
  }

  .settings {
    display: none;
  }

  .locale-menu-mobile {
    display: none;
  }
  .inner-stake-user-status {
    display: none;
  }
  .quit-max-overview-bg {
    display: none;
  }
  .question-mobile {
    display: none;
  }
  .self-host-stake-item-question {
    &.mobile {
      display: none;
    }
  }
}
</style>
